var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoscow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 595.668,
    height: 707.547,
    viewBox: "0 0 446.751 530.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h446.751v418.083l-.21 4.186-.209 4.184-.419 4.186-.627 3.975-.838 3.976-1.046 3.976-1.045 3.557-1.256 3.766-1.465 3.557-1.674 3.558-1.883 3.139-1.884 3.347-2.301 3.139-2.302 2.93-2.511 2.72-2.721 2.72-2.719 2.511-3.139 2.512-3.139 2.301-3.348 2.092-3.557 1.884-3.557 1.883-3.767 1.674-4.186 1.465-3.975 1.255-4.394 1.256-4.394 1.046-4.813.628-4.603.837-5.023.419-5.021.209-5.232.209h-55.451l-3.558.209h-3.557l-3.348.419-3.348.209-3.139.419-3.139.628-3.138.418-2.93.628-2.93.627-2.929.837-2.929.837-2.721.837-2.511.837-2.719 1.046-2.512 1.047-2.511 1.046-2.302 1.256-2.51 1.046-2.302 1.255-2.093 1.256-2.302 1.255-2.092 1.465-2.092 1.465-2.093 1.465-2.093 1.464-1.884 1.465-1.882 1.674-1.883 1.674-1.884 1.465-1.674 1.674-3.766 3.557-3.558-3.557-1.883-1.674-1.884-1.465-1.882-1.674-1.883-1.674-1.884-1.465-2.093-1.464-2.092-1.465-2.092-1.465-2.093-1.465-2.092-1.255-2.302-1.256-2.511-1.255-2.302-1.046-2.302-1.256-2.511-1.046-2.51-1.047-2.721-1.046-2.511-.837-2.93-.837-2.719-.837-2.721-.837-2.93-.627-3.138-.628-3.139-.418-3.139-.628-3.138-.419-3.349-.209-3.348-.419h-3.557l-3.557-.209H87.048l-5.23-.209-5.023-.209-5.023-.419-4.812-.837-4.604-.628-4.393-1.046-4.395-1.256-4.185-1.255-3.767-1.465-3.975-1.674-3.767-1.883-3.348-1.884-3.348-2.092-3.139-2.301-3.139-2.512-2.72-2.511-2.72-2.72-2.51-2.72-2.303-2.93-2.301-3.139-1.884-3.347-1.883-3.139-1.674-3.558-1.465-3.557-1.255-3.766-1.255-3.557-.837-3.976-.837-3.976-.628-3.975-.419-4.186L0 422.269V0Z",
    style: {
      fill: "#161413",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h441.31v415.363c0 44.779-28.668 76.377-84.328 76.377h-51.894c-39.967 0-65.495 13.811-84.328 32.434-18.832-18.623-44.571-32.434-84.328-32.434H84.537C28.877 491.74 0 460.142 0 415.363V0Z",
    transform: "translate(2.51 2.72)",
    style: {
      fill: "#a8002c",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.263 354.889c3.347-12.554 11.09-19.042 23.854-21.133 12.346-2.093 25.947-8.998 40.804-15.904 6.277-4.603 7.114-2.511 2.511 6.487l-7.115 8.161c-3.766 4.184-4.603 8.579.628 12.763 7.115 3.558 10.044 6.907 8.998 9.835-7.743-2.091-14.857-1.046-20.925 4.605-4.394-1.256-9.625-.628-16.95 2.929-3.766-2.093-7.951-2.302-12.973-.837-1.255-3.139-4.813-3.976-10.881-2.93-1.674-1.883-4.395-3.139-7.951-3.976zm85.583 0c-7.532-7.742-8.37-14.647.21-20.506 4.812-3.348 11.926-11.09 20.716-22.808 5.858-.419 11.089-1.675 16.949-2.512 23.435-2.928 45.616-7.951 63.402-17.786 3.349-1.046 5.859-.418 7.324 2.093l13.811 18.205-3.976 1.465 10.462 7.951c-1.883 1.465-.628 2.511 1.675 3.348-1.256 1.883-.419 3.766 1.465 3.557.837 2.511 2.72 6.278-2.721 1.046-3.349-1.674-3.766 0-1.047 5.232l5.651 8.161c.419 3.766 1.882 6.905 4.812 9.625l4.604 9.417c0 1.464.837 2.928 1.256 4.184.627 3.558 1.464 5.441 4.394 5.86-2.93 5.649-6.696 10.881-12.974 14.228-12.345 6.696-22.18 3.976-21.134-12.346.628-8.788 2.301-16.112 2.511-25.11 3.557-14.019.209-21.134-11.927-21.971-6.278.209-11.09.209-14.648 2.72-3.348 2.302-8.161 1.465-14.647-2.302-12.556-9.416-21.972-14.438-28.249-14.438 6.068 6.906 7.742 13.81 2.929 20.716 5.022 2.301 4.813 4.603-.21 6.905-12.135.419-25.737-2.092-39.966-6.067-4.604-.838-5.441 0-2.302 2.51 10.463 4.185 16.112 10.463 16.112 19.251-6.695.209-12.346.628-15.484 1.256-2.93 1.883-6.069 1.674-8.998-1.884zm118.645 67.588c-3.557 1.884-4.394 3.976-1.046 6.069 2.302 1.465 3.557 1.673 3.976.628 4.184-.837-1.674-3.139-2.93-6.697zm-109.438-9.207c-2.302 1.674-3.348 3.558-2.092 6.069l4.603 3.975c1.883-1.674 1.465-4.184-.627-5.858-1.047-.838-1.674-2.302-1.884-4.186zm-53.569-21.971c3.349 1.465 3.349 4.603-.836 6.487-3.139-1.256-2.929-3.976.836-6.487zm-61.1-124.295c15.065 17.368 17.786 37.038 5.44 59.846-4.603 11.09-3.975 18.204 2.092 21.553 1.675-3.767 3.14-9.626 3.977-15.694 1.255-9.416 7.323-8.37 15.275-16.531 8.579-8.789 6.068-17.996 5.231-32.643-1.465-31.388 5.022-49.593 14.229-59.846-23.437-6.486-37.665 10.881-46.244 43.315zM64.24 7.324c-2.72.418-3.766 2.302-3.347 5.44L79.516 39.13c.628 1.256 1.883 2.512 1.673 3.558-1.464 3.557-2.091 5.859 1.047 8.998l6.278 6.068c.628 4.393 1.465 7.951 2.929 9.207-1.464 2.93.418 5.65 2.93 8.37.627.837.836 1.883 1.883 2.72l1.046 8.998c-8.788 7.323-13.183 12.764-14.02 16.112-.419 1.883-.837 3.348.419 4.394l12.346-1.255c1.046.627 2.302.836 2.72 1.673 1.883 4.395-.628 11.3-7.324 12.137-15.275 3.767-26.366 8.998-21.971 19.251 5.649 7.324 2.719 13.811-6.906 19.67-2.301 2.092-3.347 4.813-2.93 8.369-2.72 2.303-4.812 5.86-6.695 9.835-1.464 4.186-1.464 6.068 1.464 5.651 21.344-7.116 42.27-10.044 57.126 2.301 7.324 6.069 6.069 9.207 17.577 9.835-1.255 4.813 0 7.532 4.185 8.369l.628 5.442c-4.604 1.046-9.835 1.046-14.439 2.302-5.231 1.254-10.252 3.347-14.856 3.347-3.976-3.138-8.579-5.021-12.346-7.323-19.251-11.928-35.364-12.556-49.383 3.766-7.324 8.58-14.02 20.297-19.46 38.293-1.046 3.138-3.558 4.394-8.58 1.464-10.043-8.16-11.927-15.484-6.905-20.296 7.114-6.697 9.835-2.721 6.069.836l.209.837c5.44 0 7.533 3.767 9.625 7.743 4.604-11.928 2.092-20.088-4.394-26.576l-1.465-.209.628 10.253c-11.09-2.301-17.16 6.279-17.996 14.23-.628 7.742 2.93 14.647 12.974 20.507 5.649 1.882 7.324 8.37 2.93 14.856-10.882 15.903-9.208 32.853.627 54.614l1.255-.627c2.093-23.855 7.115-35.991 15.067-38.293 2.51-.837 4.812-2.511 6.905-5.231 2.302-3.558 3.557-3.139 5.231.628 4.395 10.044 3.976 19.669-2.093 29.295-13.81 22.389-14.438 39.548 5.232 53.149l.628 1.674-5.232 6.696c-1.673 2.721-.419 6.069 4.186 9.835 3.348 3.976 5.021 10.463 6.067 18.623-1.673 2.511-1.882 5.65-.837 9.207 2.93 4.185 10.044 6.487 20.089 5.441 1.046-.209.836-1.046.836-2.092.838-4.605-2.302-7.952-5.649-13.602-9.835-8.789-11.928-17.159-8.788-25.319l1.465-2.302c7.742 2.72 17.577 5.859 26.574 7.115-3.767 7.742-3.348 17.368 0 23.017 6.278 10.881 12.973 15.903 25.738 14.857 16.949-1.464 25.319-15.485 19.042-34.527 6.068-3.347 10.044-3.138 12.137.628-.21 8.579 3.556 5.86 3.765 14.23-10.044 8.788-13.809 16.321-2.929 21.133 5.65 5.651 2.511 7.743-4.813 8.162-7.742-1.884-13.391-1.465-14.438 4.812-7.115.419-9.206 4.604-8.997 11.3 2.092-5.023 6.068-5.441 8.16-4.185 3.766-.21 7.742.836 11.091-.628 3.138-1.464 6.695-1.464 10.671.209 2.093 0 3.557.837 4.604 2.511 5.021 5.232 4.394-.628 15.484 6.068 2.721.209 7.325 0 8.162 4.395l1.045-3.976c.837-1.464.418-3.138-1.255-4.603-3.557-4.186 2.092-4.395 11.927-2.512 5.232 2.302 10.044 3.349 13.811 2.721 4.394-4.395 5.44-1.674 6.277 4.184 3.139-8.579 1.047-13.182-7.533-13.6 1.465-4.604 2.093 2.302 5.231-3.349 2.721-1.255 5.441 0 8.162 2.721.627-4.186-1.884-6.696-7.325-7.952-1.256-3.557-3.975-3.766-7.742-.209-15.903-4.185-17.577-13.811-8.579-15.694 4.813-1.255 6.696 3.767 10.463 5.231 2.929 1.047 4.393.628 8.37 1.047 4.394.209 8.369 1.046 11.09 2.929l3.139 1.046c1.673-1.254 3.347-1.046 5.44.837 2.302 3.349 4.604 3.767 6.696 1.047 6.278-5.022 15.694-5.022 15.066-1.884-.209 4.604.628 6.278 2.301 5.86 1.465.209 2.093 2.092 2.093 5.44-6.068-.209-10.253.837-10.253 5.232-5.65 1.673-5.44 5.649-2.929 10.88-.628-10.043 7.952-1.883 16.321-7.324l5.859-.627c.628 2.929 3.348 4.185 8.579 3.976 1.884-.838 4.813-.838 6.697-1.256 10.253-2.72 18.414-2.093 24.482 6.277 1.255-2.51 1.046-5.231-.628-7.742 7.114-4.812 14.857-2.929 10.253 4.813 4.186-2.092 8.37-12.764 2.93-12.555 2.302-6.277 11.718-1.046 8.998 3.558 3.975-2.093 4.603-5.232-.209-9.207-.628-3.558-3.558-4.604-8.789-3.139-2.93-5.023-6.696-5.232-11.718-.837-5.022 2.301-8.998 2.511-11.509-.838-2.72-4.393-2.093-6.486 1.674-5.021 1.883.628 2.721-1.674 5.023-6.069.836-1.884 2.51-3.347 3.766-5.859 5.441-.837 9.834-5.65 15.484-15.275 3.976-1.883 5.859-9.625 6.069-21.762 1.674.837 3.766.209 6.486-1.465-1.883-.209-2.72-.837-2.72-5.649h5.231c2.093-.837 2.93-1.674 2.721-2.721 0-.837-2.093-.627-3.558-2.93-.628-2.929-2.302-5.858-5.44-8.788l-5.022-8.161c-3.558-11.299-7.742-17.786-12.974-13.601l-1.464-.838c-3.976-4.393-6.906-10.252-9.207-16.739.209-7.952-8.162-8.37-12.556-.837l-1.255-6.278-2.093 3.349-13.182-19.042c1.464-.209 3.975-1.674 5.44-1.884 16.112-1.255 32.225-6.068 48.755-15.276l11.719-3.556c5.231-2.093 6.905-.419 9.625 2.302l11.927 12.345c2.302 2.511 2.302 4.813 1.046 7.324-1.255 2.511 1.674 5.859 5.86 9.416 3.766 4.185 4.184 9.835.837 16.95-1.883 4.603-1.465 7.533 1.255 8.998l8.161 5.858c5.44 4.395 8.161 2.93 7.952-4.812-.419-3.976-1.675-7.743-3.977-11.718-2.719-4.814-4.602-9.417-4.812-14.23-.209-9.625-1.465-14.647-5.441-17.995-4.603-4.394-8.579-9.416-11.717-14.857-1.047-3.139-1.884-5.022-3.558-5.859-.418-10.044-7.742-15.066-12.346-12.345-3.975.837-7.742 1.255-11.927.627v-2.302c5.231-2.929 14.229-12.137 23.227-22.181 3.348-4.184 5.022-2.51 8.37.838l12.974 13.601c-.419 6.696.628 11.091 5.23 10.672 3.14 5.44 4.604 10.671 1.675 12.973-2.93 2.511-5.231 4.186-5.231 7.742.628 5.232 6.696 10.672 13.391 13.183.628.21 1.674-.209 2.093-1.046 1.884-4.603 2.093-10.044.209-15.484l-2.302-7.742c-.418-3.139 0-5.651.21-7.953.627-6.068.837-9.416-5.65-14.019-8.16-8.37-15.067-16.949-20.716-25.947.209-11.927-10.044-15.066-16.53-2.093l-12.556 8.789c-3.139 2.093-5.231-1.256-5.231-4.604-1.255-15.693-11.927-28.249-23.645-40.385-6.277-19.042-14.857-34.945-17.996-49.592 11.928 1.255 20.925 3.557 24.482 7.114 5.232 5.65 11.928 8.579 13.602 4.604.628-1.256-3.139-3.558-5.023-5.441 2.093 0 4.813 1.883 7.743 4.813 5.231 0 6.905-3.976 5.44-9.416.628-4.395.419-7.742-1.464-9.207l-4.394-2.511c-7.325-7.952-13.393-15.903-18.414-24.692-.628-1.046-.837-1.883-.837-2.72 0-3.558-1.047-6.696-4.604-9.835l1.674-.837-.209-1.256 3.767.837-3.767-6.277c-2.093-7.742-9.207-8.998-19.879-5.859-1.465.418-3.349-1.255-5.231-3.348-6.697-6.487-13.811-10.044-11.3-5.232.419.837 2.511 3.14.209 2.93l-11.509-1.883c-2.511-.419-2.929.418-2.302 1.674 2.093 2.302 4.186 4.395 5.023 6.905l-14.648.837c-2.929.21-5.44 1.465-8.161 1.256-7.951-6.696-17.786-1.675-28.039 6.067l-1.465-.626-.209-11.928h1.255l-1.046-7.742h.837c.837-11.718-1.465-19.251-5.859-24.483-.837-3.557 2.721-3.138 3.557-4.184 3.348-4.186 3.139-8.998 3.139-11.51-.628-5.022-2.302-6.695-4.812-5.022h-2.93c-3.139-.419-5.65-1.464-6.905-2.93C190.209 0 187.07 0 183.932 2.094c-15.067 3.766-17.786 15.484-36.201 7.533-2.092-.209-2.51.628-1.673 2.302 3.138 4.184 7.533 6.905 12.345 8.998-1.673 1.255-5.022 1.464-10.463 1.046 3.139 4.184 9.207 6.277 18.624 6.068 3.557 2.092 7.743 1.256 12.346-.628 2.511-1.465 2.72-.628 1.046 2.72-4.812 3.976-8.161 11.718-8.788 25.738-1.884 2.93-2.93 6.068-3.558 9.626-6.905-1.884-12.973-3.139-15.484-1.047l-2.721-.209c-6.068-4.603-11.926-4.394-16.74-1.256l-10.671 8.161c-3.976 2.721-7.324 2.93-7.952-.418l-4.394-9.417c.209-6.695-2.302-9.834-6.906-10.252-2.092-1.884-3.556-4.185-3.975-6.697l-3.139-3.975c1.047-3.558-.419-4.813-2.93-4.813-2.719 0-5.231-.419-6.695-1.465L64.24 7.324z",
    transform: "translate(29.504 22.599)",
    style: {
      fill: "#161413",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.045 32.433 2.093-4.394c1.046-1.465 1.883-1.465 2.511-.209l5.022 4.603c-1.046 1.046-3.348 1.046-5.022 1.465l1.674 2.721-1.674.836-.628 2.303C1.882 37.246 0 34.944 1.045 32.433ZM5.44 17.367c.628 0 1.255 1.884 1.255 3.977 0 2.091-.627 3.975-1.255 3.975-.838 0-1.256-1.884-1.256-3.975 0-2.093.418-3.977 1.256-3.977zM2.51.418C2.928 0 3.975.837 4.602 1.883c.838 1.255 1.047 2.51.628 2.72-.418.209-1.464-.419-2.092-1.674C2.3 1.674 2.091.628 2.51.418Z",
    transform: "translate(394.648 307.39)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.604 28.039c-.628-.627-1.255-.418-1.883.21C.419 30.969 0 33.061 1.256 34.944l4.604 3.558c1.465 1.256 3.138.628 2.302-.628l-1.674-2.302c1.046.419 1.883 1.465 2.929 1.465.837 0 1.046-1.255 0-2.093-1.674-1.674-2.092-2.302-1.046-3.347.418-.418.418-.837-.209-1.256l-3.558-2.302zm0-19.46C2.512 6.068 2.93 4.603 5.651 4.812 3.139.837 5.86 0 8.371 4.184c1.255 1.884 1.464 5.651 1.046 10.044-.21 1.256-1.674 1.675-2.092 0-.837-2.51-1.674-4.184-2.721-5.649ZM6.278 25.11l1.047-4.813c.209-1.255.628-1.046 1.255 0 1.674 2.092 3.139 4.185 3.557 7.742.419 1.465.209 2.302-.837 2.512-1.255.209-2.302-.419-3.347-1.465-1.465-1.674-1.884-2.721-1.675-3.976Z",
    transform: "translate(405.946 259.262)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.999 25.111c.209-8.789 1.255-15.903 1.255-22.39 0-2.721 1.883-2.721 1.883.418.419 6.905-.419 14.02-1.256 21.344 0 1.046-1.882 2.93-1.882.628zm12.136 34.944c.418 0 .627.419.627.837 0 .419-.209.838-.627.838-.419 0-.628-.419-.628-.838 0-.418.209-.837.628-.837zM.419 29.086l.837-.628c.209-.208.628-.208.837.209l3.139 3.977c.209.209.209.627 0 .837l-.837.628c-.209.209-.628.209-.837-.21L.209 29.923c-.209-.209-.209-.628.21-.837Zm30.132 22.39 1.255-8.161-1.464 2.93c-1.256 0-1.465-1.255-1.674-3.767-.21-2.929 0-3.976 1.674-3.348l1.046 2.721.837-1.884c1.465-.837 1.674 0 1.047 2.511l-.419 8.998c-.837 1.256-1.465 3.558-2.302 0zm22.181-25.737c-1.256-1.674-1.465-3.767 0-5.232 1.256-1.465 3.139-1.674 4.603-.628 1.256.628 1.674 1.465 1.674 2.093l-2.51.837 3.138.837c1.674 1.465.209 4.185-1.256 1.883-1.255-1.255-2.719-1.464-4.184-.628 0 1.884-.419 2.302-1.465.838zM22.39 40.386c.419-.21 1.256.628 1.884 1.674.418 1.046.628 2.093 0 2.302-.419.418-1.256-.419-1.674-1.465-.628-1.046-.628-2.302-.21-2.511ZM3.139 38.712c.419-.21 1.256.418 1.884 1.464.628 1.256.628 2.302.209 2.512-.419.209-1.256-.419-1.883-1.674-.628-1.047-.628-2.093-.21-2.302ZM8.79 28.458c1.464-.208 3.347 1.465 3.766 3.767.627 2.511-.419 4.604-1.884 5.023-1.673.209-3.347-1.256-3.975-3.767-.419-2.512.418-4.604 2.093-5.023Zm2.719 13.811c-.837-3.976.419-4.603 1.884-.837 2.302 5.441 3.557 12.346 3.348 20.716 0 3.139-2.511 3.348-2.721.419-.837-7.324-1.046-14.23-2.511-20.298zm24.274 6.487a41.87 41.87 0 0 1 2.51-12.136c.628-1.884 1.465-2.093 2.511-1.047 3.767-6.068 2.93-2.72 1.256 1.884l1.046.627c4.603-8.579 2.721-1.673 2.302 2.092-3.348 4.186-5.65 5.023-6.696 2.093l-1.046 5.44c-.837 2.511-1.465 2.93-1.883 1.047z",
    transform: "translate(329.15 205.693)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.742 158.194c-1.465 5.649-7.742 2.72-4.603-2.302 7.742-12.555 15.275-25.11 16.74-42.059.418-6.069 4.184-8.789 8.997-11.509 10.254-5.65 13.81-15.275 13.602-26.156C40.175 28.877 53.358 8.161 73.656 0l-.628 1.883c-18.205 11.09-25.738 32.434-25.947 61.52-.209 6.486-.837 13.183 0 20.297l.627-1.464c.628-17.159.628-31.807 2.72-41.851 2.302-11.09 5.86-17.786 9.417-22.599 1.255-1.674 2.301-3.767 3.557-5.022 1.674-1.673 3.557-2.092 5.022-3.557l-.209 1.465C61.31 17.577 55.451 26.366 52.73 37.875c-2.93 13.182-3.139 28.458-2.092 44.361-.21 2.302-.628 4.185-1.465 5.858l.837-.418c1.256-2.511 1.883-5.44 1.883-8.998-1.465-19.251 0-38.712 6.905-52.312 4.814-9.417 7.743-12.974 21.135-20.507l-.419 1.465c-11.298 7.742-21.97 16.74-24.062 47.29l.627-.627C58.17 30.759 66.541 13.601 82.026 7.324c5.44-2.302 11.928-1.884 19.041-1.884l-1.254 1.047C88.932 5.44 79.515 9.207 71.355 17.786l1.255.419c7.742-7.951 16.74-12.346 28.039-9.835l-.836 1.674c-7.951-1.255-14.647 1.673-20.925 6.487v.837c7.114-4.813 13.6-7.114 19.878-5.86 2.092.209 2.72 1.884 2.092 4.395l-1.254 11.509c-.21 11.091-.838 21.971-3.558 31.806l-1.047.836 1.047-19.25-4.394 23.855c-.418 2.72-2.302 2.302-1.883-.21 1.046-5.022 2.72-11.927 3.767-19.251-1.047.209-1.884.837-2.093 2.302-1.256 10.254-2.93 18.624-5.232 21.552a103.242 103.242 0 0 0 2.51-19.46l-1.254 1.046-3.138 18.205c2.3 1.256-.628 3.139-1.465.837l1.046-10.044-.837-.209-4.395 16.113 1.465-11.091-3.767 11.091h-1.464l1.883-9.416-6.277 17.158c-1.884.418-2.093-.209-.628-3.139l3.976-11.718-1.256.209c-2.511 8.58-4.394 14.648-7.533 16.531l-1.046.209c4.394-7.742 5.022-11.508 5.23-15.275-2.301 7.324-4.602 12.555-8.788 16.95-.627-.628.21-2.511 2.72-7.116l2.303-6.067c-1.046-1.256-1.674-.838-2.302 1.046-1.465 5.231-2.93 8.788-5.65 12.137l2.72-10.253-.418-1.256c-1.884 6.068-4.394 11.3-7.952 14.438l1.675.837c5.649-3.766 13.39-2.512 21.343-6.068 1.674-.837 3.348-1.256 4.394-.419l-1.465 3.975-1.465-2.301c-.836 3.139-2.091 6.068-3.766 7.324l-.628-4.604c-3.348 7.324-5.65 11.3-5.858 7.743l.627-4.395c-2.512 2.512-4.186 5.44-4.814 8.998-1.254-.209-1.464-2.721-1.045-6.277l-2.094 7.742c-1.882.418-2.3-1.674-1.254-6.277-1.674 4.184-3.14 7.114-3.766 7.533-.837-1.256-1.047-3.349-.42-6.069l-2.091 3.976c0 2.93-.838 3.976-2.093 3.767.627-4.395.627-6.069-.21-5.023l-2.51 6.696c-1.465.837-1.883-.837-1.674-4.603-2.302 1.256-1.674 5.859-3.348 7.742-1.256-.837-1.465-2.93-1.256-5.231-1.046 3.557-2.093 5.649-3.557 5.859l-.418-6.905c-.628 3.138-1.465 5.649-2.721 7.742l-1.883-5.023-.837 4.814c-1.465.837-2.72-.419-3.557-3.558-.21 6.488-.837 11.928-5.023 14.648.419 1.674-1.464 6.068-3.976 11.091l6.697-9.835c1.465-.419 2.093.418 1.465 3.557l-6.906 11.299c-1.046 1.256-2.302.837-3.558 0-1.464 5.65-3.975 9.626-6.486 13.393 2.93-1.884 4.813-5.86 7.114-11.3.42-1.674 2.302.418 1.674 3.766l-1.674 1.465.21 2.511-2.093.209v3.349l-1.883.837c1.883 4.603-.418 7.533-5.022 5.231z",
    transform: "translate(72.61 241.894)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.465 8.161 0l-.419 1.674L0 1.465Z",
    transform: "translate(119.692 241.057)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.811c1.046-3.976 3.767-6.277 6.486-11.09C8.16 0 8.788 1.884 8.58 4.395 5.021 9.626 2.302 12.346 0 13.811Z",
    transform: "translate(43.524 292.532)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.374 18.205C71.983 6.278 58.8 0 48.965 2.093c-18.623 4.185-27.62 21.343-33.06 37.665 3.138-5.441 5.858-8.998 9.206-10.044-9.207 14.647-14.438 29.505-15.275 46.663-.628 2.093-1.674 3.975-3.348 5.44C.627 86.212 1.046 89.769 0 93.326c1.256-.837 2.72-3.557 4.604-5.858 2.51-3.14 5.44-6.488 6.696-11.928 1.883-7.324 2.72-14.647 4.184-20.088 2.093-7.115 4.186-11.928 7.952-18.205 6.696-11.09 15.275-21.135 25.11-25.319v.837c-9.625 5.231-16.53 13.182-24.272 25.528-1.884 3.139-3.14 6.068-4.814 10.463-1.674 3.975-3.348 8.579-3.767 13.81-1.254 11.3-3.975 18.623-7.114 23.018-3.348 4.394-5.44 6.277-6.068 8.37-.418 1.046-1.255 2.93-1.046 5.022 7.323-13.81 10.672-12.555 13.81-22.39C19.67 61.52 16.74 46.035 36.828 24.064h1.465c-9.626 11.09-16.112 21.553-19.46 43.943-.628 3.766-1.256 8.998-2.93 12.136-2.511 4.813-7.742 8.58-9.207 13.392l1.046-.209c2.51-2.511 7.533-8.37 9.416-12.346 6.069-11.717 3.977-27.412 11.719-39.966 10.044-16.532 17.786-25.111 30.131-29.923l1.465-.209C43.525 19.879 40.596 26.366 33.272 36.41c-2.511 3.348-4.394 6.695-6.487 12.974-1.884 5.44-3.139 13.81-4.185 20.297-1.255 8.37-4.394 13.392-7.743 17.577-1.882 2.302-3.347 3.348-4.812 5.44-1.256 1.884-2.51 5.442-3.139 7.952l1.046-.419c4.604-12.345 7.324-9.625 10.672-13.81 1.884-2.511 4.813-7.533 5.65-13.392 1.255-12.136 3.766-21.344 7.952-29.296 4.394-8.788 11.3-18.414 19.041-24.9 3.558-2.93 6.277-4.604 11.09-6.068h1.047c-5.65 3.766-9.417 4.812-13.81 8.998-7.115 6.695-14.02 16.74-17.368 25.319-3.558 8.161-5.44 17.158-6.488 26.365.21-1.255.838.628 1.256-.418 3.767-21.762 11.509-37.038 21.344-46.872 5.44-5.65 11.926-9.835 17.995-11.3l3.977-.209c-9.208 2.511-17.997 6.906-24.693 17.159l1.256-.209c8.161-8.789 16.321-12.765 24.273-14.648l1.255.209c-5.44 1.883-10.462 3.976-13.6 6.905l.417 1.255c6.07-3.975 15.276-6.067 26.157-7.114z",
    transform: "translate(43.733 220.55)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.465 7.742C.419 6.069 0 4.186 0 2.512.209 0 2.093.21 2.51 1.884c.42 3.139-1.045 3.348-1.045 5.858Z",
    transform: "translate(43.942 322.455)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.138 2.092.837C3.139.209 4.394 0 5.232.418 5.021 1.464 2.72 2.511 0 3.138Z",
    transform: "translate(69.68 349.449)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 4.184 2.72-2.929C4.187.209 5.86 0 7.116.627 6.696 1.883 3.767 3.347 0 4.184Z",
    transform: "translate(67.797 354.89)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 3.766 3.139-2.72C4.604.209 6.486 0 7.742.837 7.323 1.883 3.766 3.139 0 3.766Z",
    transform: "translate(68.007 358.656)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.348 2.929.837C4.394 0 6.069 0 7.323.628 6.696 1.883 3.557 2.93 0 3.348Z",
    transform: "translate(68.844 362.004)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.929 1.883.838C2.929.21 4.185 0 5.02.419c-.208.837-2.51 1.882-5.021 2.51Z",
    transform: "translate(70.309 365.56)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.465 1.674.418C2.51 0 3.557.209 3.976.628c-.21.627-2.093.837-3.976.837Z",
    transform: "translate(80.98 333.546)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.883 3.558.209C5.23 0 6.905.209 7.742 1.255 6.905 2.301 3.767 2.51 0 1.883Z",
    transform: "translate(78.26 336.685)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.72 2.72.628C3.975 0 5.44 0 6.486.628 5.858 1.675 3.14 2.302 0 2.72Z",
    transform: "translate(80.353 327.268)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 .628 2.72 0c1.255 0 2.511.628 2.93 1.465-.628.628-3.138.209-5.65-.837Z",
    transform: "translate(82.444 324.339)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.256 1.883.21C2.72 0 3.767.21 4.184.419c-.209.628-2.092 1.046-4.184.837Z",
    transform: "translate(76.586 379.999)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16 0 3.558.627C1.674 1.464.209 3.138 0 4.603 1.465 5.021 4.813 2.928 8.16 0Z",
    transform: "translate(74.284 374.769)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.696 0H3.14C1.465.418.209 1.465 0 2.72c1.046.419 3.976-.837 6.696-2.72Z",
    transform: "translate(73.656 372.676)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 6.696 2.093-4.394C3.139.838 5.021 0 6.696 0c0 1.465-2.929 4.394-6.696 6.696Z",
    transform: "translate(96.674 383.138)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.209 1.464 3.976 0C5.859 0 7.533.627 8.37 1.674h-.209c-.21 1.254-2.721 3.556-5.859 5.23l1.883-3.557c.418-.419.837-.837 1.464-1.255H4.395C3.557 3.138 1.883 4.393 0 5.649l1.465-2.93c.209-.418.628-.627.837-.836-.628-.209-1.256-.209-2.093-.419Z",
    transform: "translate(105.88 383.976)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.649.628c1.256-.628 5.649.418 5.023 1.883-.21 1.255-2.93 3.557-5.86 5.65l1.674-3.767c.419-.628.837-.837 1.256-1.256H6.277C5.44 4.185 3.975 5.44 2.091 6.696l1.256-3.139c.209-.209.628-.419.837-.628-.419 0-.837-.209-1.046-.209C2.51 3.557 1.255 4.394 0 5.231l.837-2.093c1.464-1.883 2.51-1.674 4.812-2.51Z",
    transform: "translate(118.646 385.44)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.115C0 3.558 2.721 1.465 7.952.837c6.068-.837 13.392.419 11.299 3.14h-.627l-1.047 2.511-2.301 4.184 1.464-4.603.628-2.302c-.628-.209-1.673-.628-2.72-.837l-1.883 1.883L9.626 8.37l2.511-4.184 1.047-1.675c-.419 0-.838-.209-1.256-.209l-1.884 1.884-3.139 3.557 2.511-3.976 1.047-1.674H8.789L7.533 3.977 4.604 7.743l2.092-4.394.628-1.047c-.836.209-1.673.419-2.301.628L3.558 6.488l.628-3.349C2.302 3.977.628 5.023 0 7.115Z",
    transform: "translate(151.288 378.325)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.067v-.418h.418L5.65 2.301C9.207.627 13.601 0 12.973 2.929c0 .209-.418.628-1.255.837 0 1.046.209 2.301.209 3.557l-1.465-3.139h-.837c0 1.674 0 3.348.209 5.022L7.742 4.602c-.418.21-.627.21-1.046.21.21 2.302.21 4.813.21 7.324l-2.93-6.069v-.418c-.419 1.255-.628 2.72-1.047 3.976l-.627-4.186C1.674 7.114.837 9.206.209 11.299L0 6.904V5.858v.209z",
    transform: "translate(131.619 382.302)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.998C2.93 6.068 6.07 2.93 8.998 0 5.441 1.465 2.302 4.395 0 8.998Z",
    transform: "translate(71.772 237.918)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.883 14.439c-.837-2.093-1.883-3.976 0-8.788C3.557 1.256 5.65 0 6.906.21c1.464 1.674-.419 5.022.418 9.207L3.976 6.488l1.046 5.649-2.511-2.72-.628 5.022z",
    transform: "translate(119.273 396.11)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.674 1.255C1.255.418.627 0 .418 0 0 .209.418 1.046.836 1.883c.628.837 1.256 1.256 1.466 1.256.209-.209 0-1.047-.628-1.884Z",
    transform: "translate(149.196 414.735)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.511 1.883C1.673.627.837 0 .418.209c-.418.209 0 1.256.837 2.511.837 1.256 1.674 1.884 2.093 1.675.209-.21 0-1.256-.837-2.512Z",
    transform: "translate(148.359 417.874)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.882 1.674C1.255.628.627 0 .418 0 0 .209.209 1.255.627 2.302c.628.836 1.255 1.673 1.465 1.464.418 0 .209-1.047-.21-2.092Z",
    transform: "translate(147.104 421.64)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.302 2.928C1.883 1.254.837 0 .418.208 0 .417 0 1.882.627 3.556c.419 1.465 1.256 2.721 1.675 2.721.627-.209.627-1.674 0-3.349Z",
    transform: "translate(144.802 423.943)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.302.21c1.256.209 2.092.627 2.092 1.046-.209.209-1.255.418-2.302.209C1.046 1.256 0 .837.209.628.209.21 1.255 0 2.302.21Z",
    transform: "translate(120.319 425.197)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.719.209c1.465.209 2.512.837 2.512 1.256 0 .417-1.256.626-2.721.417C1.046 1.465 0 1.046 0 .628 0 .209 1.254 0 2.719.209Z",
    transform: "translate(118.855 422.478)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.557.21c1.674.418 2.93 1.046 2.93 1.465-.21.627-1.675.837-3.349.418C1.465 1.884 0 1.256.209.628.209.21 1.674 0 3.557.21Z",
    transform: "translate(117.39 419.129)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.255 5.65C0 1.465 4.603 0 9.416 2.093c3.766 1.465 8.37 2.093 14.438.837 2.93-.628 6.069-.628 9.207-.21 3.139 1.675 2.93 3.14-.628 3.767-6.695 6.277-11.717 12.764-12.554 19.042-2.302-3.139 2.51-11.09 10.044-20.925-4.604 3.557-8.788 8.16-12.765 13.391.837-3.347 3.558-7.951 7.324-12.973-8.161 6.068-13.81 15.066-12.973 31.806-3.139-10.043-1.046-19.669 5.44-29.085l-8.998 9.416 8.161-12.555-5.022 1.674.419-1.883L8.37 5.86V3.767L4.184 7.115l.838-3.557c-1.465-.838-2.511.418-3.767 2.092Z",
    transform: "translate(174.097 378.116)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.419 0C0 2.511.209 5.441 2.302 8.37c.628.628 1.465-.209 1.046-1.673C1.883 5.441 1.046 2.93.419 0Z",
    transform: "translate(178.7 407.41)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.837 0c.419 0 .837 1.046.837 2.511s-.418 2.72-.837 2.72C.419 5.231 0 3.976 0 2.511 0 1.046.419 0 .837 0Z",
    transform: "translate(188.744 408.667)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.302.209c.209.209.209 1.255-.21 2.302C1.464 3.766.837 4.604.418 4.394c-.418 0-.209-1.255.21-2.302C1.255.837 1.883 0 2.302.209Z",
    transform: "translate(196.905 397.786)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.512 0c.418.419 0 1.256-.628 2.093C1.256 3.138.419 3.766.21 3.557 0 3.348.21 2.302.838 1.465 1.465.419 2.302 0 2.512 0Z",
    transform: "translate(198.997 392.973)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.557 1.256 3.975 6.277 2.092 12.346C2.301 7.323 1.465 3.348 0 0Z",
    transform: "translate(279.978 401.134)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.255 3.138C1.046 2.092.628 1.046 0 0l.628 3.766.627-.628z",
    transform: "translate(260.518 423.733)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.418 0 1.046 0 1.674.209L3.348 2.93c-.628 0-1.255-.209-1.883-.419L0 0Z",
    transform: "translate(220.76 363.678)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.627 0c.419.209 1.047 1.255 1.256 2.302.209 1.046 0 1.674-.418 1.465C1.046 3.557.418 2.72.209 1.674 0 .628.209 0 .627 0Z",
    transform: "translate(216.784 381.883)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.419.21c.209-.21.837.628 1.046 1.674.418 1.046.628 1.883.418 2.092-.418 0-.837-.627-1.255-1.674C.209 1.047 0 .21.419.21Z",
    transform: "translate(220.132 381.464)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.209 0c.418 0 1.255 1.256 1.464 2.72.21 1.256.419 1.884-.627 1.884-.837.209-.628-.419-.837-1.884C0 1.465 0 0 .209 0Z",
    transform: "translate(224.108 381.046)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.418 0c.209 0 1.046 1.046 1.674 2.721.419 1.465.628 2.929.21 2.929-.419.21-1.047-.837-1.675-2.511C.209 1.465 0 .209.418 0Z",
    transform: "translate(227.456 379.79)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.419.209C1.047 0 1.675 1.465 2.093 3.139c.419 1.883.209 3.348-.209 3.557-.419 0-1.256-1.464-1.465-3.139C0 1.674 0 .209.419.209Z",
    transform: "translate(231.222 379.58)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.419.209C.837 0 2.093 2.093 2.302 3.767c.419 1.674.628 2.51-.628 2.719C.209 6.695.628 5.859.209 3.976 0 2.302 0 .209.419.209Z",
    transform: "translate(235.407 380.209)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.418.209C1.046 0 1.674 1.464 2.302 3.348c.418 1.883.418 3.557 0 3.557-.419.209-1.256-1.255-1.675-3.139C.209 1.883 0 .209.418.209Z",
    transform: "translate(238.128 379.372)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.047 0c.418 0 1.045 1.884 1.045 4.186S1.674 8.37 1.047 8.37C.628 8.37 0 6.488 0 4.186 0 1.884.419 0 1.047 0Z",
    transform: "translate(241.894 378.534)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.837 0c.419 0 .837 1.674.837 3.558 0 2.092-.418 3.556-.837 3.556C.21 7.114 0 5.65 0 3.558 0 1.674.21 0 .837 0Z",
    transform: "translate(245.66 379.79)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.837 0c.419 0 .837 1.883.837 4.185 0 2.302-.418 4.185-.837 4.185S0 6.487 0 4.185C0 1.883.418 0 .837 0Z",
    transform: "translate(249.218 378.744)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.464 0c.628.21.837 2.093.628 4.814-.419 2.302-.837 4.393-1.465 4.393-.418 0-.627-2.091-.418-4.602C.419 2.093.836 0 1.464 0Z",
    transform: "translate(252.357 377.697)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.092 0c.628 0 .628 2.093.21 4.604C1.883 7.115 1.255 8.998.628 8.998c-.419 0-.628-2.092-.21-4.603C.837 1.884 1.674 0 2.092 0Z",
    transform: "translate(256.75 377.488)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.464.209c.628 0 1.674 3.138 1.255 6.068-.627 3.139-1.465 5.649-2.092 5.44C0 11.508.418 8.998.837 6.068 1.254 2.929 1.046 0 1.464.209Z",
    transform: "translate(261.355 374.978)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.21.209C.419 0 .838.837 1.256 1.674a6.322 6.322 0 0 1 .419 2.093c-.209.209-.837-.628-1.047-1.465C.21 1.255 0 .209.21.209Z",
    transform: "translate(241.266 398.623)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.21 0c.418 0 1.046 1.046 1.465 2.302.418 1.255.418 1.883-.21 2.092C.628 4.813.837 3.976.419 2.72 0 1.674 0 .209.21 0Z",
    transform: "translate(244.195 397.786)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.044v1.465l1.884-1.256C2.302 6.487 2.302 2.93 2.093 0 1.465 3.767.838 7.115 0 10.044Z",
    transform: "translate(272.653 378.953)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.618 35.364c-1.047 5.44-1.256 7.114-3.349 8.998.837-3.349.419-5.86.419-6.488-.628.21-1.046.419-1.465.419v.628c.209 2.092.209 4.813-2.302 8.16-.209-2.928 1.046-5.649 1.046-8.579-.628.21-1.046.419-1.674.628v2.93c-.209 1.255-1.464 4.395-1.673 4.604.209 0 1.045-6.069.418-7.325-.418.21-1.046.21-1.464.419v.837c-.21.628-.21 1.256-.628 1.256-.21 0-.419-.419-.419-1.047-.209-.209-.209-.628-.418-.837-.21 0-.628 0-1.047.209v.21c.21.627.21 1.046 0 1.255-.209 0-.627-.628-1.046-1.255-.419 0-.837.209-1.046.209.209 1.046.209 1.465-.628 1.883-1.047.419-1.047-.627-1.256-1.674-.628.209-1.254.209-1.882.419.209.837 0 1.465-.21 1.465-.209.209-.627-.419-1.046-1.256h-1.674c.209.837.209 1.256 0 1.465-.209 0-.628-.419-1.046-1.256l-.21.21c0-.21 0-.21.21-.21-.21-.209-.21-.628-.419-1.046-.628-1.256-.837-2.511-.628-2.721.419-.209 1.047.628 1.674 2.093.21.419.419 1.046.419 1.465.418-.209 1.046-.419 1.465-.419 0-.418 0-.627-.209-.837-.419-1.674-.419-3.138 0-3.347.418-.209 1.046 1.045 1.464 2.72 0 .209.21.627.21 1.046.628-.209 1.045-.419 1.673-.628-.209-1.046-.209-1.465-.209-2.093 0-.836 0-1.254.209-1.254.209-.209 1.256 1.254 1.674 2.929.419-.21.628-.21 1.046-.419-.209-.209-.209-.209-.209-.418-.418-1.256-.418-1.674-.418-2.511-.21-.628-.21-.837 0-1.046.209-.21 1.255 1.465 1.674 2.929 0 .209 0 .418.209.628.419-.21.628-.21 1.046-.419v-3.348c0-.836.21-1.255.419-1.255s.418.419.628 1.046c.209.837.418 1.884.628 2.929.418 0 .837-.209 1.255-.417v-1.675c.209-.628.209-1.046.419-1.046.209-.209.627 1.046.836 2.093.628-.209 1.046-.419 1.674-.628V33.69c0-.628.209-1.256.419-1.256.209-.209.418.209.418.837.21.628.419 1.256.419 2.093.418-.209.837-.209 1.255-.628 0-1.255.21-2.511.21-3.348.209-.837.418-1.465.627-1.465.21-.209.419.209.419 1.046.209.838.209 1.884.209 3.14.419-.21.837-.419 1.256-.419 1.465-5.859 3.347-13.811 3.347-20.925-.418-.838-.837-1.465-1.255-2.302-.418 7.951-1.046 14.648-3.557 19.041 1.256-6.486 1.465-13.391-.209-21.342h-.628c.209 8.579.209 15.693-2.093 20.505.837-6.905.628-14.228-2.092-22.389-.419-.209-.838-.418-1.255-.418 1.882 1.674 1.464 8.37.627 9.416-1.255-3.976-.21-5.232-3.766-7.952h-1.047c1.884 2.092 2.093 5.231 1.674 7.743-1.046-2.302-2.72-5.023-4.394-6.696h-1.884c2.721 3.138 2.721 3.766 2.302 6.277-1.046-2.721-5.23-4.604-6.905-5.859-.837 0-1.046.209-1.883.209 2.093 1.046 5.022 4.813 3.976 6.069-1.465-1.674-4.604-3.349-5.86-5.651-.837 0-.418.419-1.255.419.418 1.256 0 2.092.209 3.558-1.882-.419-2.929-.628-5.231-3.14-.418 0-1.255-.209-1.255 0 .209.628 1.046 2.093 1.255 2.721-.418-.628-4.812-2.93-5.231-3.558-.209-.209.836-.209-1.674-.418.209.627 1.674 3.976 1.884 4.604-.419-.628-3.558-3.977-3.976-4.395-1.047-.209-1.884-.209-2.93-.418L0 5.65c9.416.628 19.879.21 32.435-2.092l11.718-2.302c3.975-1.256 6.696.837 7.533 6.906l.627 6.695c2.512 3.557 3.558 7.952 1.047 14.02 1.046 4.394 3.556 8.161 7.323 11.299 3.349 3.139 3.767 7.533-.209 13.811-3.558 9.207-8.579 14.857-12.974 20.926 0 .209-.418.418-.418.626-.209.21-.418.419-.627.838.209-.419.418-.628.627-1.046l-.627-3.139c.627.837.836 1.465 1.045 2.302l1.884-3.139a97.693 97.693 0 0 1-.628-3.348c.418.837.837 1.465 1.255 2.302.419-.837 1.047-1.675 1.465-2.512-.418-1.046-.627-2.301-1.046-3.556.628.837 1.046 1.673 1.465 2.51.628-1.045 1.256-2.092 1.674-3.138-.209-1.046-.628-2.093-.837-3.139.419.628.837 1.256 1.256 2.093.627-1.884 1.046-3.349 1.255-4.605L33.69 71.355c1.884-1.674 3.975-3.139 5.859-4.813l-.21.209c-.209-1.255-.418-2.719-.627-3.975.627 1.046 1.046 2.302 1.465 3.347.418-.417 1.046-.836 1.465-1.254l-.628-5.023c.837 1.465 1.255 2.93 1.674 4.186.628-.419 1.256-1.047 1.883-1.465-.209-2.093-.418-4.395-.837-6.696 1.047 1.882 1.674 3.766 2.093 5.649.628-.628 1.046-1.046 1.673-1.465-.209-2.929-.627-6.277-1.045-9.416 1.464 2.93 2.51 5.65 2.51 7.951.419-.418.837-.628 1.256-1.046-.21-3.138-.628-6.905-1.256-10.253 1.674 3.139 2.721 6.278 2.93 8.789 0-.209.418-.419.628-.628 0-3.348-.628-7.952-1.256-12.137 2.093 3.976 3.139 7.743 2.721 10.463l1.255-1.256c-.209-6.067-2.302-11.509-4.185-17.158-.837 2.929-.837 3.975-1.674 3.766.418-3.347.209-4.812-.419-5.231-.418 4.603-1.465 7.533-2.929 8.998l.837-7.533h-1.255z",
    transform: "translate(224.944 358.237)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.674 0c0 1.256 0 2.302-.837 2.302C0 2.093.209 1.047.419 0h1.255z",
    transform: "translate(250.055 406.783)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.673 0c.419.21.628.628.628 2.092 0 1.465 0 2.511-1.046 2.511C0 4.394.209 3.138.627 1.883 1.045.419 1.255 0 1.673 0Z",
    transform: "translate(252.357 404.482)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.674 0c0 2.301 0 3.975-.837 3.766C0 3.556 0 1.882.418 0h1.256z",
    transform: "translate(255.286 404.9)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.627 0c.21 0 .21.419.419 1.046H0C.209.419.418 0 .627 0Z",
    transform: "translate(255.914 401.97)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.302 0c.419 0 .628.838.628 2.721 0 1.882 0 3.557-1.465 3.347C0 5.859.419 4.185.837 2.302 1.465.628 1.674 0 2.302 0Z",
    transform: "translate(257.169 401.552)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c5.232 1.256 10.672 5.651 16.114 10.254.836 1.464.418 1.883-.838 1.255C11.509 10.254 6.069 3.976 0 0Z",
    transform: "translate(245.032 341.497)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.302.837c1.046.628 1.465 1.256 1.255 1.465-.209.418-1.046.209-2.093-.419C.628 1.255 0 .418.209.209.418 0 1.255.209 2.302.837Z",
    transform: "translate(262.819 354.262)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 5.649.628L6.905 2.72l-.209-.209c-.628 0 1.883 6.696-1.465-.418-.419-.837-1.675-.628-2.72-1.047C1.465.628 1.883.418 0 0Z",
    transform: "translate(212.39 362.84)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.884 0c1.045 0 2.091.418 2.091.837 0 .209-.627.628-1.674.628C1.047 1.465.21 1.255.21.837 0 .418.837 0 1.884 0Z",
    transform: "translate(184.35 453.237)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.719.628C4.393.209 6.277 0 6.486.419c.419.418-.837 1.046-2.511 1.674-1.674.418-3.348.418-3.766 0C0 1.674 1.045 1.046 2.719.628Z",
    transform: "translate(186.234 457.84)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.348.628C5.232.209 7.115 0 7.534.419c.209.418-1.046 1.255-2.93 1.674-2.092.627-3.767.627-4.185.209C0 1.884 1.256 1.046 3.348.628Z",
    transform: "translate(187.279 459.515)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.302.418C3.557 0 4.813 0 5.022.418c.209.209-.627.836-1.883 1.255-1.465.209-2.721.209-2.93-.209C0 1.254 1.046.627 2.302.418Z",
    transform: "translate(190.837 461.608)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.674 0c1.255 0 2.092.418 2.092.836.209.419-.628.628-1.673.628C1.046 1.464 0 1.255 0 .836 0 .418.628 0 1.674 0Z",
    transform: "translate(193.139 463.7)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.719.628C4.393 0 6.068 0 6.277.837c.418.628-.837 1.883-2.511 2.511-1.675.628-3.348.628-3.557-.209C0 2.511 1.045 1.465 2.719.628Z",
    transform: "translate(214.483 454.702)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.302.628C3.557 0 4.813 0 5.022.628c.209.628-.628 1.465-1.883 1.884-1.255.628-2.511.418-2.72 0C0 1.884 1.047 1.047 2.302.628Z",
    transform: "translate(211.97 452.818)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.674.418C2.72 0 3.557.209 3.766.418c.21.628-.418 1.256-1.464 1.465-1.047.419-1.884.419-2.093 0C0 1.465.627.837 1.674.418Z",
    transform: "translate(209.879 449.262)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.883 1.047C1.674 0 .628 0 .209.837 0 2.302.418 4.185 1.883 5.022c1.674.837 2.093-.837 1.256-1.465-.837-.837-1.047-1.464-1.256-2.51Z",
    transform: "translate(179.328 431.266)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.138 1.884C3.348.628 2.301 0 1.465 1.047.419 2.511 0 4.812 1.256 6.277c1.464 1.884 2.72.21 2.301-.837-.628-1.463-.837-2.301-.419-3.556Z",
    transform: "translate(175.143 428.964)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.674 2.093C.418 3.976 0 11.091 6.278 19.67c2.301 2.93-.419 5.022 2.929 5.44 1.255-.209 2.092-1.255 2.302-3.138l-2.093-1.046h2.93l-3.139-2.093c1.046-.209 3.557.419 3.348-.628-.209-1.255-3.139-1.465-4.604-2.093l3.558-.837c.209-1.046-1.884-1.883-5.231-2.928l3.347-.837-3.766-2.302 2.929-.838-4.603-2.302 2.51-1.255-2.719-.837 2.51-1.255C4.395 1.884 3.557 0 1.674 2.093Z",
    transform: "translate(322.665 334.8)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.465 11.927C.21 9.207 0 6.906.628 4.813 2.092 1.046 3.557 0 4.813 0c2.511 2.72-1.675 4.394-2.512 6.487-.627.419-.836 1.883-.836 5.44Z",
    transform: "translate(317.852 330.407)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.674 1.673C2.72.628 3.975 0 4.393.419c.419.418-.209 1.464-1.255 2.719C2.093 4.185.837 5.022.418 4.603 0 4.185.628 2.929 1.674 1.673Z",
    transform: "translate(316.597 327.687)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.465 0C2.092 0 2.72.628 2.72 1.465c0 .627-.628 1.255-1.255 1.255C.628 2.72 0 2.092 0 1.465 0 .628.628 0 1.465 0Z",
    transform: "translate(315.76 342.753)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.51.418c.837.21 1.046 1.255.419 2.301-.419 1.047-1.255 1.674-1.883 1.256C.209 3.766 0 2.719.628 1.673 1.046.628 1.883 0 2.51.418Z",
    transform: "translate(317.434 346.52)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.975.419c1.046.419 1.256 1.465.418 2.721-.627 1.046-2.092 1.674-3.139 1.464C.209 4.186 0 2.93.627 1.884 1.254.838 2.719 0 3.975.419Z",
    transform: "translate(318.899 350.913)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.976.837c.628.837.209 1.673-.837 2.092-.837.419-2.093.209-2.721-.627C0 1.674.209.837 1.255.419 2.302 0 3.348.209 3.976.837Z",
    transform: "translate(322.037 355.308)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.044 7.533c.418-.628.418-1.674-.628-1.883-1.046-.209-1.674-.209-2.301-1.256C6.278 1.883 7.533.628 9.625 0c1.674 0 2.302.628 1.884 1.674l-1.047.837c1.884.628 3.139 1.256 3.767 2.302-1.046 0-1.674.209-1.883 1.046 3.557-.627 3.348 5.022.209 3.976-2.093-.628-3.139.209-2.093 3.767.837 4.184 3.767 5.23 3.558.836-.419-2.092 6.696-2.511 7.533 2.092l-2.721-1.045c.628 3.347 3.348 1.882 3.767 4.812l-2.302.21c2.721 1.883 4.813 4.185 5.86 6.904-2.93-.418-3.139-3.556-5.86-3.556 3.558 4.812 7.742 3.766 9.835 8.579-2.93-.209-6.486-2.511-10.463-6.278 3.558 5.023 5.86 9.207 5.023 11.299-5.232-2.301-6.278-10.044-8.37-12.345 0 3.976 2.929 6.278 1.882 10.671-2.091-2.51-3.138-6.486-3.138-12.763 2.092.418 2.929-1.047 2.929-4.604-.419-3.766-2.301-3.557-1.882 0 0 2.72-1.884 3.557-7.534.209-.837.837.418 1.884 3.557 3.767l-.209 3.138 1.674-2.72.628 8.789c-.209 2.302-.837 1.883-1.465-.418l-.628-4.395c0 3.139-.418 4.604-1.464 4.395l-.838-8.161-2.301 2.929-.627-4.603-2.093 1.674v-5.651c-1.465.838-3.139.21-4.813-2.301 2.302.628 3.767.21 5.65-.837-1.047-4.185.837-6.278 4.394-6.696Z",
    transform: "translate(331.035 351.123)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.72 6.069c.209-1.883.628-2.511-1.255-5.023C.628.209 0 0 .21 1.046.628 2.72 2.302 4.395 2.72 6.069Z",
    transform: "translate(288.557 378.116)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.721 1.465 3.976 1.674 5.44 5.65.419 1.464.21 2.511-.837 1.255C2.93 5.023 2.093 1.884 0 0Z",
    transform: "translate(287.929 371.42)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.557 2.512 5.021 2.93 6.696 8.789.418 2.302-.21 3.558-1.465 1.674C3.138 7.533 2.511 3.14 0 0Z",
    transform: "translate(288.348 363.259)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.975 1.255 6.905 6.068 6.905 10.252 0 2.302-1.046 3.767-1.674 1.675C4.394 8.998 2.929 2.929 0 0Z",
    transform: "translate(290.022 357.4)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.558 1.465 5.86 3.975 7.116 7.742.209 2.093 0 3.139-1.465 1.465C4.814 6.068 2.721 2.93 0 0Z",
    transform: "translate(291.695 354.262)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4.186C.837 2.093 3.975 0 7.742 1.675c1.674.418 1.464 2.511 1.464 3.976C8.16 4.605 7.114 3.349 6.067 4.605 3.138 2.303 2.092 3.558 0 4.186Z",
    transform: "translate(316.388 453.655)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.256 0c.837 0 1.465.418 1.465 1.256 0 .627-.628 1.046-1.465 1.046C.628 2.302 0 1.883 0 1.256 0 .418.628 0 1.256 0Z",
    transform: "translate(303.832 458.678)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.418.209C.837 0 1.465.837 1.883 1.883c.209 1.047.209 2.092-.209 2.092-.419.209-1.047-.418-1.465-1.673C0 1.255 0 .209.418.209Z",
    transform: "translate(297.346 458.469)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.418 0c.209 0 .627.418.837 1.255.209.628.209 1.256-.21 1.465-.209 0-.627-.419-.836-1.256C0 .836 0 .209.418 0Z",
    transform: "translate(299.857 458.26)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.695 10.881c-.209.209-.418.419-.418.628-.836.837-1.673 1.465-1.883 1.047-.418-.21-.209-1.256.419-2.093l.837-.837c-.209-.21-.209-.419-.419-.628-.209.209-.209.418-.418.628-.837 1.046-1.884 1.674-2.302 1.255-.419-.209-.209-1.465.628-2.511.209-.419.627-.628.837-.837-.21-.209-.21-.419-.419-.419C2.72 8.161 1.674 8.579 1.255 8.37c-.418-.419-.209-1.465.628-2.511a.45.45 0 0 1 .419-.419c-.419-.418-.419-.628-.628-.837-.628.419-1.047.628-1.465.419-.209-.21 0-1.047.628-1.883-.419-.837-.628-1.674 0-2.093C2.092 0 2.72 1.465 3.976 4.184c.418 1.047 0 1.675.628 2.302.418.838 1.673 1.256 2.091 1.884 1.465 2.302 1.256 4.186 1.047 4.395-.419.209-.209-.209-1.047-1.884z",
    transform: "translate(294.207 420.385)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.975.418c.628.417.21 1.673-.836 2.929C2.093 4.602 1.046 5.23.628 4.812 0 4.393.419 3.137 1.256 1.882 2.302.627 3.557 0 3.975.418Z",
    transform: "translate(296.927 432.94)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.302.209c.209 0 0 1.256-.419 2.511C1.465 3.975.628 4.812.209 4.603c-.209 0 0-1.256.419-2.511C1.255.837 1.883 0 2.302.209Z",
    transform: "translate(324.339 420.804)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.976.209c.418.21.209 1.884-.628 3.767C2.302 5.649 1.255 7.114.627 6.905 0 6.696.209 5.021 1.255 3.139 2.092 1.256 3.348 0 3.976.209Z",
    transform: "translate(319.526 419.548)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.72.209c.419.21.21 1.465-.418 3.14C1.674 4.813.837 5.86.418 5.651 0 5.441.209 4.186.837 2.721 1.465 1.047 2.302 0 2.72.209Z",
    transform: "translate(313.458 416.618)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.21 4.604C.837 1.674 2.721.21 4.814 0l4.602.837c1.675 1.256 1.466 1.675-.418 1.884-3.766-.628-5.859.209-6.905 2.72C.628 7.532 0 7.741.21 4.603Z",
    transform: "translate(112.995 58.59)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.047 0c.418 0 1.046.418 1.046 1.255 0 .628-.628 1.256-1.046 1.256C.419 2.51 0 1.883 0 1.255 0 .418.419 0 1.047 0Z",
    transform: "translate(126.806 71.982)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.465 5.858C0 7.742.418 9.834 2.93 12.346l3.348 4.184c2.929 2.093 4.394 1.674 3.975-1.465-.418-2.091.209-2.93 2.093-2.93 1.255-.208 2.093-.836 2.721-1.882.418-1.674.209-2.51-1.256-2.93-2.721 1.884-5.022 2.72-6.905 3.139 2.51-1.674 4.393-2.929 5.021-3.976.628-.628 1.465-.837 2.721-.419 0-1.046-.419-2.091-1.883-2.51-2.93 0-5.859 2.092-8.58 5.022 1.674-3.558 4.186-5.65 7.952-5.65.209-1.046 0-1.883-1.047-2.72C8.789 0 6.487.627 4.604 2.092L1.465 5.858z",
    transform: "translate(111.112 61.938)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c6.906 6.697 12.764 14.648 17.369 23.646v7.742l-2.512-8.789c.209 6.069 0 10.045-.628 8.789l-2.092-12.555-1.465 5.441-1.255-7.742c-1.046-.837-1.256 3.975-1.046 10.671-1.884-1.883-1.674-7.324-1.465-13.392L4.813 19.67c-1.256-3.138-.628-7.324 0-11.3-1.256-1.046-2.093 1.046-2.511 7.325-1.465-4.186-1.047-7.534-.419-11.509L.418 7.324 0 0Z",
    transform: "translate(129.526 93.744)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.93 6.486C5.232 8.16 8.371 8.58 11.509 8.58l.209 1.674c5.023 0 10.254-2.302 15.485-5.86-.209-.208-1.255-.417-2.302 0-3.767 1.884-3.348.629 3.766-2.93 1.047-.626 1.884.21 3.558-.417L36.829 0c-3.767 3.348-7.534 6.695-11.718 9.834-5.86 3.349-11.091 4.186-15.904 2.512-2.72-1.256-5.44-2.93-7.951-4.814C.628 6.486 0 5.858 2.93 6.486Z",
    transform: "translate(177.863 28.249)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.837 0c.628 0 1.047.419 1.047.838 0 .418-.419.837-1.047.837-.418 0-.837-.42-.837-.837C0 .418.419 0 .837 0Z",
    transform: "translate(208.832 35.781)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.418.837C.837.209 1.256 0 1.674.418c.419.21.419.837 0 1.256-.418.628-1.046.837-1.256.628C0 2.092 0 1.465.418.837Z",
    transform: "translate(215.528 47.5)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.256.209C1.884 0 2.511 0 2.721.419c.209.418 0 1.256-.837 1.465-.628.418-1.256.418-1.465-.21C0 1.257.419.629 1.256.21Z",
    transform: "translate(229.548 42.478)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.419.627C1.046.209 1.674 0 1.883.418c.419.209.21 1.047-.209 1.465-.628.419-1.255.628-1.465.21C0 1.883 0 1.255.419.627Z",
    transform: "translate(227.037 39.758)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.047.209c.628-.209 1.254 0 1.464.419 0 .418-.419 1.046-1.046 1.046-.627.209-1.255 0-1.465-.418C0 .837.419.418 1.047.209Z",
    transform: "translate(203.6 44.57)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.466.418C2.302 0 3.349 0 3.558.418c.209.419-.209 1.047-1.256 1.465-.836.21-1.883.21-2.092-.21C0 1.257.419.629 1.466.419Z",
    transform: "translate(211.343 59.846)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.929 6.277c2.301-.209 5.441-1.046 9.626-2.93l4.812-2.301c2.302-1.046 2.721-.837.837 1.047-2.092 2.092-4.813 3.138-6.695 4.602-1.884 1.256-4.604 2.93-9.207 1.675C0 7.742.837 6.486 2.929 6.277Z",
    transform: "translate(183.095 39.758)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.675 8.998c2.72-2.51 4.394-3.139 8.16-4.812 3.558-1.465 7.114-1.884 10.672-1.884C23.018 0 25.32 3.139 22.6 5.65c-.837.837-1.884 1.256-2.93 1.883-2.721 2.093-5.649 2.93-8.579 3.767-3.767 1.046-4.186.628-1.047-1.465 1.047-.837 1.884-1.465 2.93-2.093 2.302-1.464 4.813-1.883 7.115-2.092-3.558-2.3-10.463 1.256-17.368 4.604C.628 11.3 0 10.672 1.675 8.998Z",
    transform: "translate(198.997 34.944)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 .419C1.465 0 2.721.21 4.395.21c2.719.837 3.975 2.302 4.184 4.184-.627 1.884-1.465 2.93-2.72 3.348-.628-3.348-1.883-5.23-3.766-5.858-.837-.21-1.256-.21-2.093-.21V.42z",
    transform: "translate(219.504 32.643)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.464.837C2.301.419 2.51.209 3.348 0v1.256l-1.675.418C.836 1.883 0 1.256 1.464.837Z",
    transform: "translate(214.9 33.061)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.837 3.557C2.721 1.883 4.812.418 7.324.209 9.835 0 12.555 0 15.275.418c5.232 1.884 3.139 3.558-.209 2.302-2.093-1.256-4.603-1.046-7.533 0-.209 2.092-3.767.419-5.859 1.884C.209 5.23 0 4.812.837 3.557Z",
    transform: "translate(211.762 28.249)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.674 0 2.93.209 3.139 1.674.209 1.884-.209 3.349-1.465 4.185C2.302 1.884.419 2.302 0 0Z",
    transform: "translate(227.874 32.434)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.093 3.767c.419.628.628 2.301 0 5.021L.419 11.927c-.419 1.465 0 1.884 1.046 1.465 1.674-1.046 2.51-2.511 2.51-4.604 0-3.139.21-4.603 1.256-5.65C3.349 0 1.465.419 2.093 3.768Z",
    transform: "translate(230.385 27.621)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.696c0 2.093 4.813 2.511 5.44.21C6.486 4.394 4.603 2.51 5.231 0 2.092.837 0 3.139 0 6.696Z",
    transform: "translate(219.086 43.105)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.837 2.512C1.883.628 3.558 0 6.069.21c1.882 0 2.929.418 2.929 2.302 0 1.882.209 3.975-.21 5.65-.627 1.673-.837 1.464-2.928 1.673-2.302 0-3.14-1.046-5.651.419C1.674 6.696 0 5.23.837 2.512Z",
    transform: "translate(216.993 52.73)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.047 2.302C0 .628 1.256 0 2.302 1.256c1.256 1.046 2.093 2.51 2.093 3.975.209 1.465-1.465 2.72-2.511 1.465-1.047-1.255.209-2.51-.837-4.394Z",
    transform: "translate(225.78 44.78)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.628 2.303C0 .21.837 0 3.349 1.047c1.674 1.465 1.883 2.51 1.046 3.348 1.674 1.674 1.674 3.976.209 6.696-1.046-.837-2.302-.42-3.139-1.674-.209-.837-.837-.419-.418-3.558.209-1.255.209-2.301-.419-3.556Z",
    transform: "translate(227.246 52.73)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.674 0C2.72 0 3.348.628 3.348 1.256c0 .627-.837 1.046-1.674.837C.628 2.093 0 1.465 0 .837 0 .419.837 0 1.674 0Z",
    transform: "translate(229.13 72.191)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.093.209c1.046 0 1.883.628 1.674 1.256 0 .628-.837 1.256-1.883 1.047C.837 2.512 0 1.884.209 1.256.209.628 1.047 0 2.093.209Z",
    transform: "translate(215.737 70.099)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.228 4.604c-1.256-2.092-4.395-3.557-8.999-4.185C11.3 0 7.324.838 3.139 1.884.837 4.394 0 8.16.419 13.184l1.884.418-1.675 1.255H2.93L1.465 16.95l1.256.418-1.046 2.72 1.255.838-.627 1.674 1.674.209-.419 1.673 1.255.21-.418 1.674 1.255.42c.837 1.254 2.302 2.3 3.976 3.347 1.256.628 2.511.628 3.976.418 2.51-1.883 3.138-3.557 5.231-5.859.628-.21.837-1.464.837-3.348 1.256-.627 1.674-1.674 1.674-3.139l1.047-1.465v-5.02c-1.256.418-2.093.628-3.139.418l-2.93-1.255-.837 6.486c0 1.256-.628 3.139-2.092 2.51l-3.558-1.673c-.837-.418-.628-1.674.419-2.092l1.255-.21v-5.65c-2.092.629-4.394.838-6.487-.627-.836-.418-1.673-.418-2.51-.418.627-1.256 1.465-2.303 2.301-2.93L3.558 4.395c.419 0 1.255.209 1.882.209 2.93-.21 4.395-.628 5.232.21.837.836 1.465 1.464 2.302 1.882l.209-1.465c.628-1.673 1.883-2.091 3.767-1.464l-.419 4.185 6.697-2.093V4.603zM7.743 21.762a13.812 13.812 0 0 1 5.859 0c3.348.837 3.557 2.092.418 3.975-1.883 0-3.975 0-6.068-.628.628-1.046 1.255-1.465-.209-3.347zm2.511 1.464c.837-.627 2.093-.627 3.348 0 .627.418.418 1.046-.209 1.465-.837.21-1.465.21-2.302 0-.628-.628-.209-1.047-.837-1.465z",
    transform: "translate(210.506 63.402)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.628 0c.418 0 .627.21.627.628 0 .209-.209.419-.627.419-.21 0-.628-.21-.628-.42C0 .21.418 0 .628 0Z",
    transform: "translate(220.76 80.143)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.139c0-.42.209-.837.209-1.465C1.256.627 1.674 0 1.674 1.046c0 .837 0 1.465-.209 2.093H0z",
    transform: "translate(224.735 67.379)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.37C.209 5.65.628 3.35 1.046 0h1.465c-.21 2.302-.419 4.814-1.256 8.79-.418.836-.836.417-1.255-.42Z",
    transform: "translate(223.48 72.4)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.301 1.674C2.092 0 3.766.209 3.975 1.674c.419 2.93 0 5.231-1.464 6.696C1.464 8.998 0 8.37.836 7.114c1.465-2.091 1.884-3.556 1.465-5.44Z",
    transform: "translate(205.066 64.658)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.419 2.51C0 .628 1.256 0 1.674 2.093c1.465 5.65 3.976 11.09 9.626 16.322 2.302 1.883-.209 3.557-2.301 1.674C3.348 15.274 1.674 8.579.419 2.51Z",
    transform: "translate(205.693 75.749)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.209 5.65C0 3.974.628 2.301 2.511.836 3.767 0 4.185 1.465 3.557 2.302 2.302 3.767 1.255 3.767.209 5.649Z",
    transform: "translate(226.828 89.769)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.814 8.788c.209-1.464.418-2.511 1.255-3.557a6.338 6.338 0 0 1-1.464-1.047C3.558 6.486 2.093 8.37 0 11.09 1.465 6.696 2.93 3.347 6.069 0c-.418 1.464-.837 2.72-1.255 3.766.418.418 1.046.837 1.465 1.256.418-.419.837-.838 1.046-1.256 0 .628 0 1.256-.209 1.884h.209l-.209.627-.209-.209c-.419 1.046-1.047 1.674-2.093 2.72Z",
    transform: "translate(167.609 109.857)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.929C.209 1.673.627.836 1.464 0 1.255 1.464 1.046 1.882 0 2.929Z",
    transform: "translate(169.912 119.483)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.022c.209-.837.418-1.674.628-2.302l.418-.419c0-.209.21-.628.419-.837C1.883 1.046 2.302.419 2.72 0 2.511 2.51 1.883 3.348 0 5.022Z",
    transform: "translate(181.002 119.064)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.627 4.813C0 2.721.627 1.256 3.139 0c0 3.139-.21 3.976-2.512 4.813z",
    transform: "translate(179.956 125.34)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.602C2.092 8.58 2.301 6.278 1.673 0 3.975 5.859 3.557 7.533 0 13.602Z",
    transform: "translate(185.606 114.669)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.388 31.806c1.047-4.395 1.465-8.579 1.256-12.974-.418.209-.628.209-1.046.419-.21 2.302-.837 5.021-2.093 8.37.628-2.721 1.046-5.441.837-8.161-.418.209-.837.418-1.256.418-.209 1.884-.837 3.975-1.674 6.696.419-2.302.628-4.394.628-6.486-.628 0-1.255.209-1.882.209-.21 2.721-.628 5.649-1.256 9.416 0-3.139-.209-6.277-.209-9.207H22.6c0 3.138-.419 6.277-1.046 10.672-.21-3.767-.21-7.325-.419-10.881-.628-.209-1.256-.209-2.093-.419 0 3.349-.418 6.696-1.046 11.3-.209-3.976-.419-7.742-.419-11.509l-1.882-.628c-.209 3.139-.837 6.278-1.674 10.463 0-3.767 0-7.114.209-10.881l-1.883-.628c-.21 4.185-.628 7.951-.837 12.346-.628-5.441-1.047-9.207-.628-12.974-.628-.209-1.256-.418-1.674-.837-1.047 5.023-1.465 9.416-1.047 14.439-1.464-6.488-1.673-10.254-.209-14.858-.418-.418-.836-.627-1.255-.837-.628 1.675-1.674 3.558-2.93 5.651 1.047-2.093 1.465-4.186 2.093-6.069-.628-.419-1.465-.837-2.093-1.255-.418 2.72-1.674 5.44-3.767 9.207C2.721 16.111 2.93 9.834 3.14 1.883c.627 3.138 1.046 5.649 1.046 7.951.837.419 1.465.628 2.302 1.047.419-3.558.628-6.905.628-10.881 1.045 4.603 1.464 7.951.836 11.09.628.209 1.256.628 1.883.628.209-.419.628-1.047 1.047-1.674l-.628 1.883c.418 0 1.046.209 1.465.209.418-1.255.628-2.72 1.255-4.394 0 1.674-.209 3.139-.209 4.813.628 0 1.047.209 1.674.209 0-1.046.21-2.302.21-3.558.418 1.465.418 2.512.627 3.767.628 0 1.465.21 2.092.21V8.369c.419 1.884.837 3.349 1.046 4.814.838.209 1.675.209 2.512.209 0-1.674 0-3.139.209-5.023.419 1.884.628 3.558 1.046 5.023h2.093V5.858c.837 2.93 1.256 5.232 1.465 7.325.628 0 1.255-.21 1.882-.21 0-1.674-.418-3.557-.627-5.441.837 1.884 1.465 3.558 1.674 5.232.418 0 .837-.209 1.256-.209-.21-1.884-.628-3.767-.838-5.86.838 2.093 1.465 3.767 1.884 5.441.418 0 .837 0 1.256-.209-.419-2.93-.628-6.069-1.256-9.625 4.813 11.926 4.813 17.367.418 29.504z",
    transform: "translate(188.325 115.507)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.418 15.066.837 1.883 2.93-2.72c.837-1.047 1.674-.837 2.302.628l.209-3.349c1.047-.627 1.884-.209 2.72.837.628-.837.628-1.882.209-3.138l.419-4.185C8.37 2.301 7.115.628 5.231 0c1.047 2.301 1.047 4.185.419 5.859-.209-2.721-1.465-4.603-3.558-5.65.837 1.674 1.256 3.348.837 5.022-.418-.628-1.046-1.255-2.092-1.883l.418 2.511L0 6.696l.418 8.37z",
    transform: "translate(225.154 118.436)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.882 0c0 .628 0 1.047-.418 1.047C1.045 1.047.627.628 0 0h1.882Z",
    transform: "translate(242.94 118.645)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.929 0c.418 1.046.837 1.883.837 2.511H1.465C1.046 1.883.627 1.255.209.419 0 .419 0 .209 0 0h2.929Z",
    transform: "translate(240.639 115.088)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.628 0c.628 0 2.092 1.255 3.139 3.139H1.046C.209 1.465 0 0 .628 0Z",
    transform: "translate(239.174 111.112)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.209.209C.418 0 1.255.837 2.093 2.092c.627 1.255.836 2.302.627 2.511-.209.209-1.046-.628-1.674-1.883C.209 1.465 0 .209.209.209Z",
    transform: "translate(238.337 118.227)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.419.209C.628 0 1.675 1.046 2.721 2.511c.837 1.673 1.256 2.929.837 3.138-.209.21-1.256-.837-2.302-2.302C.419 1.674 0 .419.419.209Z",
    transform: "translate(234.15 117.39)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.626.418 1.045.837 1.464 1.046L2.51 0C2.301 1.463 1.882 1.882.836 2.928c.209-.628.418-1.255.628-1.674C1.045.837.626.418 0 0Z",
    transform: "translate(166.983 109.439)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.674 0 .837 2.72 0 2.301.419 0h1.255z",
    transform: "translate(146.685 319.317)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.047C2.72 0 3.348 1.256 4.185 4.394 6.486 6.487 7.95 8.161 7.95 9.835c4.813 3.975 3.976 5.649-2.51 5.022-2.093-.628-3.348-2.092-3.348-5.022L0 1.047Z",
    transform: "translate(83.491 410.55)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.674 2.302C0 4.813.419 7.952 2.51 10.462c1.256 1.465 2.72 1.884 4.185 1.884l-.837-2.302 2.511 1.674c0-1.256-1.046-2.721-3.347-4.394l3.138.837c0-1.674-1.465-3.139-3.976-4.395h2.092C5.231.837 3.347 0 1.674 2.302Z",
    transform: "translate(82.863 425.407)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.047.209C1.884 0 2.51 1.047 2.72 2.302c.21 1.256-.209 2.302-1.045 2.51C1.047 5.022.21 3.977 0 2.721 0 1.465.419.209 1.047.209Z",
    transform: "translate(91.651 428.964)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 19.67C0 12.974 2.93 6.486 6.696 0 3.976 6.696 1.674 13.183 0 19.67Z",
    transform: "translate(135.176 266.167)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.72 7.114C.209 8.16 0 6.067 1.883 4.603 5.859 1.255 10.254 0 15.275 0h8.789c3.348 0 2.93 3.348-.21 3.139h-6.277c-5.65-.21-10.253 1.464-14.857 3.975Z",
    transform: "translate(147.522 239.802)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.185 0C6.487 0 8.37.418 8.37.837c0 .628-1.883.837-4.185.837C1.884 1.674 0 1.465 0 .837 0 .418 1.884 0 4.185 0Z",
    transform: "translate(165.099 243.777)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.023.419C4.604 0 3.558 1.465 2.093 3.349.838 5.023 0 6.696.21 6.696c.209.209 1.465-1.045 2.72-2.929C4.395 2.093 5.231.419 5.023.419Z",
    transform: "translate(181.42 198.997)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.047 9.626C0 11.508.419 12.555 2.512 13.392c8.37 2.511 16.531-.21 24.691-4.813l10.253-4.813C39.34 1.464 38.921.837 36.41 1.673l-5.021 2.512L32.644 0c-2.72 2.092-4.395 4.185-5.65 6.487l-.837-2.093c-1.255 1.046-2.301 2.511-2.72 4.395l-1.046-2.302c-1.047.627-1.884 1.465-2.512 2.72l.419-2.93c-.837-.627-2.093.837-3.767 4.186l.837-3.139c-.627-.628-1.673.628-3.138 3.765l3.347-10.043c-1.674.21-3.975 3.976-6.486 10.671-1.046.21-1.465-.209-1.256-1.045l3.767-7.325c-1.883-.209-3.976 2.512-6.487 7.325l2.93-8.371-5.441 7.115v-2.72c-1.255.418-2.511 1.465-3.557 2.93z",
    transform: "translate(170.748 204.229)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.837 1.674C0 .837 1.465 0 1.884.419l2.511 2.302c.627.628-.837 1.674-1.465 1.255L.837 1.674z",
    transform: "translate(172.004 348.402)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.419 1.464C0 .837 1.046 0 1.465.419l2.092 2.092c.628.627-.628 1.464-1.045 1.046L.419 1.464z",
    transform: "translate(174.306 346.938)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.837 1.884C0 1.047 1.465 0 2.092.628l2.511 2.511c.628.627-1.046 1.674-1.465 1.046L.837 1.884z",
    transform: "translate(175.143 344.636)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.836 2.512C0 1.465 1.882 0 2.929.628l3.766 3.767C7.742 5.442 5.23 7.116 4.603 6.279L.836 2.512z",
    transform: "translate(176.19 340.869)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.256 2.929C0 1.674 1.674 0 2.721 1.047l4.603 3.975c1.255 1.046-.627 2.93-1.673 2.093L1.256 2.929z",
    transform: "translate(179.746 337.103)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.046 2.511C0 1.465 1.256 0 2.302.837l3.975 3.348c1.047 1.046-.628 2.511-1.464 1.883L1.046 2.511z",
    transform: "translate(182.676 335.429)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.836 2.093C0 1.256 1.046 0 1.882.628l3.349 2.93c.837.836-.628 2.301-1.256 1.673L.836 2.093z",
    transform: "translate(186.443 334.592)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.302 1.046C2.302 0 .628.418.419 1.255L0 5.022c0 .837 1.884.419 1.884-.209l.418-3.767z",
    transform: "translate(168.237 311.993)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.883 1.674C1.674 0 0 .837 0 1.883l.418 2.929c0 1.465 2.093.628 1.884-.209l-.419-2.929z",
    transform: "translate(163.216 316.597)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.673 1.465C1.464 0 .418.419.418 1.465L.209 4.186c-.209 1.465 1.464.837 1.464 0V1.465z",
    transform: "translate(157.148 320.78)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.627 0c.419 0 .836.419.836 1.047 0 .628-.417 1.046-.836 1.046C.418 2.093 0 1.675 0 1.047 0 .419.418 0 .627 0Z",
    transform: "translate(166.146 317.015)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.047 0c.628 0 1.046.628 1.046 1.256 0 .837-.418 1.255-1.046 1.255C.419 2.511 0 2.093 0 1.256 0 .628.419 0 1.047 0Z",
    transform: "translate(159.867 320.78)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.674 1.256C1.674 0 0 0 0 1.047v2.511c0 1.256 1.883 1.046 1.883.209l-.209-2.511z",
    transform: "translate(154.009 323.292)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.837 0c.628 0 1.047.627 1.047 1.464S1.465 3.138.837 3.138C.419 3.138 0 2.301 0 1.464S.419 0 .837 0Z",
    transform: "translate(200.253 166.355)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.627 4.812C.209 4.812 0 3.766 0 2.51 0 1.046.209 0 .627 0c.419 0 .838 1.046.838 2.51 0 1.256-.419 2.302-.838 2.302z",
    transform: "translate(202.974 165.518)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.675 0c1.046 0 1.883.418 1.883.837 0 .209-.837.628-1.883.628C.837 1.465 0 1.046 0 .837 0 .418.837 0 1.675 0Z",
    transform: "translate(205.902 169.284)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.628 0c.419 0 .837.419.837.837 0 .628-.418 1.047-.837 1.047C.419 1.884 0 1.465 0 .837 0 .419.419 0 .628 0Z",
    transform: "translate(209.04 172.84)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.256 0h7.742c2.511 0 2.929 1.256 1.255 3.558.838 4.184-4.394 6.905-4.185.209-.419-1.256-1.884-1.884-4.812-1.884C0 1.465 0 .209 1.256 0Z",
    transform: "translate(211.762 172.632)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.837 0c.628 0 1.046.419 1.046 1.046 0 .628-.418 1.256-1.046 1.256C.418 2.302 0 1.674 0 1.046 0 .419.418 0 .837 0Z",
    transform: "translate(200.044 221.806)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.256 0c.627 0 1.255.628 1.255 1.465 0 .627-.628 1.255-1.255 1.255C.418 2.72 0 2.092 0 1.465 0 .628.418 0 1.256 0Z",
    transform: "translate(196.277 222.852)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.813 3.138C7.534 1.256 10.253 0 10.672.628c.418.628-1.465 2.72-4.394 4.813C3.348 7.324.837 8.37.209 7.743 0 7.115 1.883 5.022 4.813 3.138Z",
    transform: "translate(196.905 222.015)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.93 2.302C4.604.837 6.278 0 6.487.209c.418.419-.836 1.884-2.51 3.349C2.302 4.813.628 5.86.419 5.441 0 5.023 1.256 3.558 2.93 2.302Z",
    transform: "translate(208.832 216.365)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.927c.626-1.464 1.254-2.929 2.091-4.185l-.418-.209c.418-2.511 2.302-4.395 4.813-5.65l.419.209C7.742 1.256 8.788.628 10.043 0c-.627 1.046-1.046 2.092-1.674 2.929l.628.418C10.461 1.883 12.345.628 14.437 0c-1.255 1.674-2.511 2.929-3.976 4.185l1.256.837c1.883-1.675 4.185-2.93 6.069-3.766-1.465 1.464-2.93 3.138-4.604 4.603l1.465.837c1.883-1.465 4.185-2.511 6.277-2.93-1.046.837-2.092 1.674-2.929 2.511 1.464-.418 3.138-.418 5.231-.628-2.721 1.256-4.394 1.675-6.487 2.512l1.674 1.046c2.092-1.256 4.394-1.883 6.278-1.883-1.465.837-3.139 1.883-4.813 2.72l1.464.837c1.884-1.046 4.186-1.464 6.069-1.255-1.674.627-3.139 1.255-4.604 2.091l.837.628c1.884-.837 3.767-1.254 5.65-1.254-1.673.626-2.929 1.464-4.394 2.091l1.256.628c1.674-.628 3.347-.628 4.812-.418-1.256.418-2.51.627-3.766 1.255l4.394 2.721-.837.418-6.696-2.302c-.419 0-.628.21-.837.419 0-.209.209-.419.418-.628l-1.674-.418c-.837.418-1.883 1.046-2.929 1.464.627-.837 1.046-1.464 1.674-1.883l-1.674-.628c-.837.419-1.883 1.047-2.929 1.465.418-.628 1.046-1.465 1.674-2.093l-1.674-.627c-1.256.837-2.302 1.674-3.558 2.302.628-1.047 1.256-1.884 2.093-2.721l-2.302-.836c-1.047 1.045-2.093 1.882-3.138 2.719.209-1.046.836-2.302 1.673-3.138l-2.092-.837c-1.046 1.047-2.302 2.092-3.558 3.138.628-1.255 1.256-2.51 2.093-3.556L3.975 8.37C2.928 9.626 1.463 10.881 0 11.927Z",
    transform: "translate(205.276 222.643)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.835 0c-2.72 5.44-5.44 13.81-7.323 30.76-1.047 7.533-1.675 15.066-.21 22.808.837 4.185 2.72 5.65 4.603 5.441l31.179-5.022c2.302-.419 4.604-2.302 3.557-4.394l-1.255-2.511-1.047 3.556-1.674-2.929-1.255 3.348-1.884-4.185-1.464 5.022-1.883-3.975-1.046 4.184-1.047-3.557-1.255 4.394-1.466-3.975-1.255 4.812-1.673-4.603-1.256 3.348-1.465-2.72-1.046 2.511-1.465-2.093c-1.465-.627-2.93-.627-4.394 0l-.628 1.046-.837-1.046c-2.302-.627-4.813-1.046-7.115-1.464l2.93-1.465c0-1.047-1.046-1.465-2.93-1.256l3.139-2.302-3.348-.628 3.139-1.883c0-.836-.837-1.673-3.347-2.72l3.347-1.046v-.837L4.814 36.2l3.556-1.674c.419-.837-.628-1.465-2.93-2.302l2.93-.837c-.209-.836-.418-1.882-2.511-2.719l2.511-.838-2.511-1.883 3.139-1.256c0-1.046-.419-1.465-2.302-2.302l3.348-1.464c-.209-.627-1.046-1.674-3.139-2.302l3.139-1.046-2.511-1.674 2.93-1.256-2.302-.837 2.72-1.674c.628-.627-.418-1.255-2.72-1.464L11.3 9.416l.209-1.255-2.93.418 1.465-1.255-1.883-1.465 4.395-1.047.418-.837-3.139-.837 2.511-1.464C11.928.419 11.091 0 9.835 0Zm4.812 4.394.628-.209c-2.719 14.857-3.975 29.086-1.882 41.85-1.047-19.879 1.464-41.013 5.23-44.57l.628 1.464c-4.394 15.904-4.812 30.132-1.883 42.897-1.883-21.762-.209-34.317 3.557-41.014v2.093c-2.929 15.275-3.138 27.621-.418 37.665l.837-.628c-1.883-15.902-.837-28.248 1.674-40.594l1.464.209c-2.929 16.113-2.929 28.667-.836 40.176l.836-.837c-1.673-16.53-1.464-28.04 1.047-38.502l1.255.209c-2.302 15.904-2.511 28.458-.419 38.712l.838-.21c-1.674-17.367-.838-29.713 1.465-38.92l.837.837c-1.674 13.811-1.465 25.947 0 37.456l.837-.419c-.419-15.066-1.256-26.993.628-35.782l1.046-1.255c-1.465 11.09-1.465 23.436.419 37.246h.837c-1.465-16.321-1.047-28.667.626-38.711l.837.628c-.837 13.183-.837 25.11.21 38.293l.837-.21c-.837-17.995-.209-30.34 1.674-37.665 1.674-.628 1.674 1.465.209 3.767-1.046 10.881-1.465 21.762 0 33.689l1.256.209c-1.256-17.367-.209-27.412 1.674-37.246 1.046-1.047 2.093.209.837 2.72-1.465 12.137-2.302 20.716-1.046 34.526h1.465c1.673.628 1.882 1.256.209 1.884-10.253 2.092-20.088 3.976-29.504 4.604-1.884.209-2.512-.837-2.512-3.558-.628-14.856 1.047-28.458 4.603-40.804Zm34.527 8.579 1.256-6.277c1.465-.837 2.092-.419 1.883 1.255l-2.72 5.231-.419-.209zm-2.302-6.696c-1.465 10.463-1.465 16.74-2.511 27.621l.837 1.884c.209-12.137 1.884-19.879 3.558-29.086.628-1.674-1.047-2.093-1.884-.419Zm-3.139-.418c.628-.837 1.674-.628 1.465.418-1.674 8.998-2.719 19.67-2.929 31.807h-.628c-.627-11.718-.209-22.181 2.092-32.225ZM.21 74.284a26.414 26.414 0 0 1 1.464-10.463c.419-1.464 1.884-2.302 4.394-2.511l28.04-4.184c1.465-.21 1.674.627 1.465 2.51-.419 2.721-.838 5.232-2.093 7.325-1.045.837-1.255-2.721-1.045-8.161-2.093 5.021-1.256 10.253-4.604 11.089-1.466-2.301.837-6.696 1.255-10.044-3.139 2.93-2.093 6.488-4.813 10.254-1.045.209-.836-3.348-.209-8.998-1.464 4.185-2.72 7.534-4.185 8.998-.837-1.255-.837-4.394-.628-7.742-1.255 5.441-2.72 9.206-3.976 9.834-.418-3.138-.209-6.068.21-8.998l-.628-.627c-.837 5.232-1.674 8.37-2.929 9.835-1.047-2.93-1.256-6.278.418-9.626h-1.255c-.837 2.721-1.256 5.023-2.512 5.86-1.674-.21-2.511-2.093-2.511-5.232C4.604 69.262 2.512 72.401.21 74.284Z",
    transform: "translate(172.004 241.057)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.368 12.973c-1.674 1.256-2.301 2.72 1.046 2.511-2.301 2.093-2.511 3.558-.628 4.185-4.184 5.231-4.184 6.696-.209 4.394-4.603 5.859-3.975 6.696-.837 5.65-3.975 4.813-3.348 5.441-2.092 5.65-2.721 3.766-2.721 5.649-.209 5.44-2.093.837-3.558 2.511-3.976 5.86C9.625 50.01.628 53.777 8.16 56.916c2.303 1.255 4.186 4.394 5.651 9.835.628 2.929 1.883 3.138 4.394 2.092 2.092-.628 4.185-.837 6.278-1.047 3.975.419 4.184-3.975-.21-4.603.419-1.674-1.046-2.511-3.348-1.465 1.884-3.139-.418-2.302-1.255-2.72 1.255-.628 1.046-2.092-2.302-.21l-.419-1.046c1.883-.627 2.511-1.673 2.721-2.929l-5.65 1.884c1.674-1.465 2.511-2.511 2.302-3.558l-3.976.837c4.185-2.93 5.859-5.022 5.649-6.068l-4.393 1.255c3.138-2.51 5.23-4.603 5.021-5.859l-3.766 1.465c0-1.255 1.674-2.511 4.813-3.348 2.511-1.256 3.766-2.93 3.348-5.231l-5.65 2.72c4.604-4.185 8.37-7.952 9.416-10.462-.419-1.465-5.022 1.673-11.09 6.696v-1.047c5.859-3.976 10.254-8.579 13.601-13.811l-11.09 8.58 10.044-11.927c-.628-1.465-3.557.209-9.207 6.068l.418-1.256 5.232-5.649c3.975-2.302 6.486-5.232 8.161-8.789 1.046-2.72-2.511.837-7.952 5.65-1.255 1.256-2.72 1.883-4.185 3.348L33.48 2.929l.21-1.674C32.434 0 24.273 9.626 17.368 12.973ZM2.302 64.658C0 63.193 2.511 59.845 4.185 61.31l6.278 4.604c1.883 1.464 0 3.975-1.465 2.929l-6.696-4.185zm2.511-3.976c-2.302-1.465.419-4.394 1.884-3.139l3.347 3.348c1.883 1.675.628 3.139-1.046 2.302l-4.185-2.511zm13.392 12.556c-1.674-.838-2.511.418-1.465 1.255a39.305 39.305 0 0 0 8.789 5.649c3.138 1.675 6.487 1.884 9.626 1.884 2.301 0 3.347-1.465.418-2.093-5.441-1.465-10.881-3.139-17.368-6.695zm1.674-.21c-1.047-1.256-.837-2.302.628-3.139l7.533-.628c1.464 0 2.72.837 3.976 2.511l3.557 3.977c1.464 1.882.209 3.347-1.255 2.928a86.054 86.054 0 0 1-14.439-5.649z",
    transform: "translate(207.786 243.15)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 35.991c1.255-2.302 3.139-3.976 5.859-5.022 7.115-1.046 14.229-2.511 20.925-5.022 2.092-1.465 2.929-1.046 2.72 1.256-.628 6.486-1.465 11.927-3.347 13.601V29.505l-.837.209c-.628 5.65-1.465 9.835-2.93 11.508l.418-10.462h-1.046L19.46 41.013l.628-8.998c0-1.255-.419-1.464-1.047-.837-1.463 10.462-3.347 14.857-5.44 16.322 2.093-6.696 2.093-11.3 1.675-15.276l-.628-.418c-.628 5.441-1.465 10.672-3.349 14.648-2.092-3.139 1.884-8.579 1.047-13.811h-.419L8.161 45.617c-1.255 0-.837-1.675.418-5.023l.418-7.323-.627.418c-1.046 3.976-2.092 6.905-3.557 9.417l.628-9.626-2.721 6.905.21-5.649L0 35.991zm30.969-7.951c.209-2.302 2.721-1.674 1.674.628l-1.255 2.928h-.628l.209-3.556zm-.628 8.579c.21 0 .419.628.419 1.465 0 .837-.209 1.465-.419 1.465-.209 0-.418-.628-.418-1.465 0-.837.209-1.465.418-1.465zm1.047-3.139c.418 0 .627.209.627.837 0 .419-.209.837-.627.837-.419 0-.837-.418-.837-.837 0-.628.418-.837.837-.837zm-.21-12.764c.628 0 1.047.836 1.256 1.883.209 1.046.209 2.092-.419 2.092-.209.21-.837-.627-1.046-1.674-.209-1.046 0-2.092.209-2.301zm-3.139-6.069c1.884 1.884 2.093 3.558 1.884 5.023-.21 2.092-1.884 3.557-1.884 2.092-.209-1.883 0-3.975-1.464-6.487-.837-1.046.628-1.465 1.464-.628zm-15.275-3.766c.21-2.092 1.884-.418 1.884.837l-.628 3.348c-.628.628-.837.209-1.465-1.046l.209-3.139zM5.441 21.762c-1.675 1.046-1.675 1.883.209 2.511l.837-.209v.209c0 .837.419 1.465.837 1.465.419 0 .837-.628.837-1.465v-.628l1.883-.418v4.185c-.628.209-1.256.209-2.092.419 0-.419-.418-.628-.628-.628-.418 0-.837.418-.837.837 0 0 .209.209.209.418-.418.21 0 .21.838.837l14.019-3.139c4.185 0 5.231-3.139 4.185-8.16.628-1.675.21-2.302-1.256-2.093l-3.139-.418 1.884-1.256c2.511-1.256 2.511-1.884.418-1.884l-4.394-.627 3.557-.627c1.047-.21 1.465-1.465-.209-2.093l-3.767-.419 2.93-.627c1.883-1.465.837-2.512-2.721-2.93 1.256-1.465 1.047-2.511-.418-2.511-.628-1.464-2.51-2.511-1.883.209l.838 13.811c.417 1.465-.21 2.511-1.884 3.139L5.441 21.762zm7.951-5.441c.628 0 1.046.419 1.046 1.047 0 .628-.418 1.046-1.046 1.046-.418 0-.837-.418-.837-1.046 0-.628.419-1.047.837-1.047zm8.37 4.395a.45.45 0 0 1 .419.419c0 .417-.21.627-.419.627s-.419-.21-.419-.627c0-.21.21-.419.419-.419zm-.837-2.72c.837-.209 1.465 0 1.674.418.209.628-.418 1.047-1.256 1.256-.837.209-1.464 0-1.674-.628-.209-.209.419-.837 1.256-1.046zm-9.626 8.997h.419v-4.185l-1.046.419.627 3.766zm2.302-.627c.419 0 .628-.21 1.047-.21V22.18l-1.884.419.837 3.767zm2.512-.837c.209-.21.418-.21.627-.419v-3.348l-.837.209.21 3.558zm1.882-.838s.419 0 .628-.209c1.465-1.674 1.465-2.511-.209-2.93h-.419v3.139z",
    transform: "translate(235.198 260.308)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.59 1.465C41.223 0 32.853 5.649 28.249 11.509c-3.975 5.02-6.068 10.672-6.487 16.949.419 1.046 2.302-1.256 5.022-4.812l-1.673-.628c.418-1.256 1.045-2.302 1.882-3.558.419-.628.419-1.674 1.465-2.302 1.256-.628 2.093-1.883 2.093-2.301h-1.465c4.813-5.86 11.509-7.325 19.042-7.115 2.092.209 3.976.418 5.859.628 1.046.209 2.092-.21 2.72-.628.628-.419.837-1.046-.209-1.046-6.696-1.047-13.392-.628-19.879.836 4.813-3.138 11.718-3.347 21.553-2.928 3.976.208 4.185-2.721.418-3.14ZM28.249 113.204c.628.419.837 1.674.418 3.139-.418 1.256-1.465 2.303-2.092 2.093-.836-.209-1.046-1.674-.628-2.93.628-1.465 1.465-2.511 2.302-2.302zm-15.066 6.069c.21 0 .628 1.046.628 2.092 0 1.256-.418 2.093-.628 2.093-.418 0-.628-.837-.628-2.093 0-1.046.21-2.092.628-2.092zm1.256 7.324c.628-3.976 2.51-7.533 5.858-9.835 2.93-2.093 3.558-1.465 1.256 1.465-2.093 2.72-3.348 6.068-5.022 8.998-.627 1.255-2.511 2.719-2.092-.628zm8.788-15.904c-2.93 1.046-5.232 2.93-6.696 5.65-1.046 2.512-.627 2.721 1.255.837 1.884-2.092 4.186-3.348 6.278-5.022.837-.628 1.675-2.092-.837-1.465zm-17.995 14.02c-1.465 1.884-1.256 2.512 1.255 1.465 3.976-6.069 6.696-10.044 8.998-11.3l7.114-6.277c5.441-1.255 8.58-7.115 9.626-16.95l-.419-1.254c-2.72 6.905-5.859 11.926-10.044 14.647-3.767 2.72-6.905 6.068-9.835 10.044-1.255 1.255-1.255 2.72-2.302 4.394-1.255 1.674-3.347 3.348-4.393 5.231zm-1.674-4.394c-1.256 2.302-.21 3.139 1.046 1.255 4.812-6.696 8.161-11.299 13.182-15.484 4.604-3.558 11.3-10.044 14.02-18.623 1.675-5.023-.209-6.487-1.464-3.35-2.721 7.534-5.859 14.23-10.882 18.206-5.649 4.604-11.718 9.835-15.902 17.996zm-.628-6.905c-1.047 1.883-1.256 3.348-.419 4.394 3.976-1.465 2.721-7.742 12.556-12.764 1.255-1.674.837-2.302-1.256-1.674l-9.207 6.696c3.138-5.022 6.277-8.998 10.881-10.044 2.929-.418 5.65-1.674 8.161-4.394 1.046-2.302.628-2.93-1.047-1.884-5.65 3.767-10.462 5.232-14.857 8.579-3.975 3.349-6.696 7.534-7.742 12.346l2.93-1.255zm-.628-12.137c1.674-3.557 6.277-5.86 12.765-7.951 4.393-1.466 7.951-4.604 11.089-8.37 3.348-2.093 2.721-.21 1.674 2.092-1.255 2.093-2.091 2.72-4.184 3.976-2.511 2.092-6.278 3.976-9.207 5.23-3.558 1.257-6.906 3.35-10.044 7.116-1.884 1.464-2.721.836-2.093-2.093zm9.835-11.927c3.139-1.883 5.858-3.767 7.951-6.906 2.93-4.184 4.186-4.393 3.349 0-.838 3.558-3.349 7.325-8.58 9.207-4.394 1.675-5.65-.418-2.72-2.301zm13.183-9.625 1.464-7.533c.209-2.93 1.256-5.651 3.139-7.953l2.302-6.277c.628-2.511 1.674-2.302 1.674.837l-1.465 3.976c1.256.627.628 1.883-.209 3.139-.209 1.465-.209 3.139-1.674 3.557-.419 5.65-1.047 10.254-2.721 11.718-2.51 3.139-3.347 2.72-2.51-1.464zm-10.044-1.047 3.347-8.16c.837-2.93 2.302-4.604 4.186-4.814l4.603-4.393c1.046-1.256 1.674.418 1.046 1.464l-3.347 5.44c-.628 4.394-2.302 8.37-6.278 12.974-.838.837-2.302.837-1.465-.418l3.976-7.952-5.022 6.906c-1.465 1.883-1.674.418-1.046-1.047zm-5.86 3.348c1.884-5.022 2.511-7.742 4.395-9.417 2.302-2.3 2.929-2.091 1.465.628-1.047 2.093-2.511 5.023-2.511 10.254 0 4.185-5.232 3.348-3.349-1.465zm-.418-6.696c.209 1.674.418 1.255 1.255 0l1.884-5.231c2.092-1.883 5.021-3.976 7.742-7.324 1.256 1.883 3.558.209 7.114-4.603 4.395-2.093 6.488-5.44 7.743-9.626 1.046-3.558.419-4.185-1.883-1.883-3.349 4.394-5.86 6.069-7.114 9.206-3.977 1.256-7.116 5.65-11.719 7.743-1.255.837-1.674 2.092-1.674 3.767-1.883 1.255-3.139 3.348-3.348 7.95zm.418-10.253c.419-.628 1.256-.838 1.675-.628.418.418.418 1.255-.21 1.883-.418.837-1.256 1.047-1.883.628-.209-.42-.209-1.256.418-1.883zm23.227-35.782c2.929-3.558 6.487-6.068 9.835-7.533 3.976-1.674 3.766 1.465 1.047 1.465-2.093 0-5.023 1.882-9.835 7.95-1.256 1.675-2.721.21-1.047-1.882zM5.022 71.983c-.627-7.534 1.047-11.928 4.603-14.44 9.626-5.858 12.974-14.437 16.114-14.228 3.138-5.441 7.951-11.09 13.6-16.322 4.186-2.93 5.023-2.301 2.721 2.302-6.069 8.579-12.137 18.832-17.577 21.762-2.511.21-4.395 1.675-5.86 3.976l3.767-1.883c1.884-.21 2.093.417.837 1.673-3.139 1.674-8.37 9.835-9.625 4.604-2.093 3.975-5.651 3.348-5.86 7.324l-.419 5.232c-.836 1.463-1.463 1.463-2.301 0zm37.247-54.825c1.884.209 2.72.837 1.256 2.51-4.604 1.885-8.998 5.44-13.183 10.464.418 1.884-.419 3.558-2.512 4.812 0 3.139-1.883 4.604-5.021 5.023l-4.604 5.858c1.046 1.465-.628 3.767-3.976 7.116-2.092 2.3-2.929 1.673-2.511-2.093 2.511-6.906 7.324-16.95 9.626-16.95 1.255 0 1.255-.418 1.674-2.72.209-1.674 1.883-1.255 1.465 0-.209 1.674.209 1.884 1.256.628 5.23-8.58 10.88-12.974 16.53-14.648zm-14.02 2.093c3.767-4.394 10.253-7.324 22.39-7.114 2.511.209 2.093 2.72-.209 2.51-1.884-.208-3.976.628-5.859 1.046-2.302.628-4.813.837-6.906 2.093-4.184 2.302-7.951 6.069-11.3 11.3-1.254.628-1.464.209-.836-1.256 4.185-7.533 9.207-11.51 14.438-11.928l.209-.418c-2.93-.627-6.486.628-11.718 5.44-.628.629-.837 0-.209-1.673zm4.604-6.487c4.603-2.93 9.835-4.604 15.903-3.766 3.766.418 3.766 2.72 1.674 2.51-5.859-.836-11.509-.627-17.159 2.093-2.092 1.047-1.674 0-.418-.837z",
    transform: "translate(227.037 85.793)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.465 2.93C0 1.047 1.046 0 3.557.209c6.487 1.256 12.136 2.093 15.694 5.022 2.093 1.465.418 2.93-1.046 1.883L13.81 4.813c.209 1.883-1.464 1.046-3.975-1.046-1.675 1.673-3.767.837-6.069-1.674l1.465 4.184c.209.837-.628.837-1.047.21L1.465 2.93zm8.997 3.347c-.837.628.21 2.093.838 2.721.837.837 1.882.418 1.464-.837-.209-1.256-1.464-2.51-2.302-1.884Z",
    transform: "translate(287.51 78.469)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.301 7.951c-.628-.418-2.092-1.046-.209-1.465C0 5.231.837 3.556 2.301 3.348c5.65-.21 10.044-3.348 16.531.209l2.929 3.348c1.884 4.394.21 6.487-2.301 3.348-1.255-1.883-.209-3.558-3.348-5.022 1.674 3.14 2.93 6.278 2.93 9.836 4.812 4.602.418 5.649-.837 2.72l-1.884-8.58c.419 4.184.628 7.324 0 7.324-1.465 0-.627-2.93-1.255-6.487-.419-1.465-.838-4.186-1.675-4.395-3.556-1.255-6.905-.209-9.625 0 4.604-.209 7.742 0 8.788 1.256 1.465 2.092 1.674 4.394 1.047 6.487-1.047 1.675-1.675 1.256-1.675-.837l-.627-2.72c-.21-1.465-1.883-1.674-4.185-1.465-1.465.21-3.139.627-4.813-.419Z",
    transform: "translate(309.064 82.026)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.255 15.694a224.688 224.688 0 0 0 23.227 31.807c1.047 1.255.21-2.512 1.047-1.047 1.883 3.976 4.812 7.742 6.068 8.998 1.255-1.047-2.72-4.603-3.348-8.789l11.927 13.811c1.046-1.883-5.859-10.044-11.508-17.159l.837-.837 13.601 17.787.627-.209c-2.092-5.86-8.37-12.974-12.555-19.461l.419-1.464c2.511 3.138 5.859 7.951 8.579 11.926 3.976 5.65 7.534 10.672 8.579 11.091 5.023 1.255-11.926-16.531-19.669-31.387l.21-.837c9.207 14.019 17.367 26.783 26.365 32.642 1.046.628 1.884-.628.837-1.883-8.161-9.626-17.786-20.088-23.646-29.504l.419-.837c8.788 10.463 13.392 22.389 30.132 32.434 1.047.627 1.674 1.674 2.721.836 3.766-2.929-14.439-7.323-28.459-30.969l.21-1.673c5.231 7.114 6.068 9.207 10.88 14.229 6.697 7.323 17.159 15.902 18.833 14.648 1.674-1.465-15.066-12.974-24.064-26.995l.419-.418c7.114 9.835 17.158 21.762 31.806 29.295 2.092 1.047 1.256.837 3.766.837 6.488.419-14.438-10.253-25.319-22.18l.209-1.046c3.14 2.719 7.115 6.277 11.509 9.835 5.231 3.766 10.672 7.114 15.066 9.625 3.976 2.092 7.114 3.348 8.579 2.72 3.767-1.883-14.437-8.37-19.042-13.183 2.721 1.466 5.441 2.512 7.742 3.557 7.953 3.976 13.602 6.697 14.858 5.232.837-1.046-3.348-3.348-10.672-6.069-.837-.836-.209-1.045 1.883-.627 8.37 3.348 13.183 5.65 14.229 5.022 2.72-.837-1.674-2.721-6.696-5.859 6.278 2.72 11.719 5.231 14.647 4.394 1.047-.209-3.556-2.721-7.533-6.277 5.651 3.556 19.042 8.37 6.279-.628l.836-.419c4.813 3.558 10.881 5.022 3.557-.837h1.047c4.185 3.349 6.486 5.859 3.348-1.046 4.185 6.069 8.37 8.37 2.72-.419l6.487 5.023c-2.302 1.046-2.092 1.673 0 2.929 5.44 3.557 5.859 2.93 4.813 0 .627-5.65-1.466-9.417-5.231-11.718-4.186-2.72-3.977.419.837 7.952-1.884-1.465-3.349-3.139-4.395-4.813-.837-1.675-2.721-2.72-4.812-2.72-9.835.209-19.461 2.092-28.668 3.347-7.115 1.047-12.555 0-15.066-1.674-2.512-2.092-3.348-2.929-2.093-5.231.837-1.883 0-3.348-1.255-3.976l-6.697-13.391c.838 1.465 1.884 2.093 2.721 3.347 2.721 4.395 4.603 7.952 5.231 7.743-1.046-2.93-4.603-9.416-7.324-16.741 5.232 9.207 9.835 17.16 11.091 16.113-.628-3.557-4.813-10.462-8.998-17.577 1.256 1.255 1.674 1.674 2.511 2.72 1.674 2.093 3.138 3.976 3.976 3.558-3.348-6.905-6.905-11.3-10.672-12.556-5.859-2.092-9.416-2.93-8.58.837L47.71 4.185l-3.139-.419c-1.047.419.418 2.093 2.511 5.651l-.628.418-3.558-5.65c-1.046-.628-2.511-1.255-2.72 0l1.883 3.767-3.975-4.395c-1.883-1.045-3.976-1.464-3.976-.627l5.859 9.626c-1.046-1.465-2.72-2.93-4.185-5.023-2.302-3.139-4.185-5.44-6.905-5.858-2.72-.209 2.72 4.184 6.486 13.182L26.366 1.884c-.837-.628-4.395-1.256-4.604 0L32.225 16.95c-4.813-5.44-9.626-10.044-12.346-15.275-.627-.628-1.255-.628-1.883-.628-.419-.209-.837 0-1.256.419l12.765 16.53c-2.511-2.302-5.023-4.813-6.906-7.114-2.72-3.767-5.231-6.278-7.324-9.626-.837-1.046-2.511-.628-2.72-.209-1.046 1.465 9.625 12.345 14.23 18.832-6.488-6.068-11.51-11.927-16.114-18.832C8.58 0 7.115 0 6.487 1.047c-.628 1.255 12.974 14.228 18.205 22.389-7.115-7.533-14.021-14.647-19.67-22.389C4.185 0 1.674 0 1.674 1.047c0 2.093 11.718 12.764 21.134 25.738C15.903 19.252 7.533 9.208 3.976 7.115c-1.675-.209 4.185 7.114 17.577 22.39-6.696-6.069-12.764-12.555-18.414-19.46-1.675 1.465 5.65 10.671 16.322 22.389L2.72 14.857c-2.301-1.465-2.72-1.256-1.465.837Zm71.146-3.975c-1.465-2.093.628-3.139 2.302-.628 3.347 5.649 6.486 10.463 8.788 15.903 1.047 2.511-.418 3.139-1.465.837-2.72-6.068-6.068-10.881-9.625-16.112Zm-6.487-2.093c-1.046-1.674 1.674-2.72 3.766.209 4.814 6.696 8.998 13.392 12.346 20.298 1.884 4.184 0 5.231-1.883 1.465-3.975-8.162-9.207-15.276-14.229-21.972Z",
    transform: "translate(251.938 230.594)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.108 8.37c-.209 3.766 1.884 8.58 5.859 11.718 0-.628-1.883-3.558-3.138-6.069-1.256-2.93-1.883-5.23-2.721-5.649zm12.973 130.572c-.418-6.068-3.766-10.463-10.461-15.484.209 1.463 4.393 5.021 6.905 9.416 2.511 4.185 2.511 5.231 3.556 6.068zm-.209-6.277c-.836-.628-1.464-2.93-3.557-6.278-2.092-3.557-5.65-7.115-5.859-8.161 5.441 3.976 8.998 9.625 9.416 14.439zm-.836-7.952c-.628-.627-1.256-2.302-2.721-4.813-1.674-2.721-4.394-5.44-4.604-6.277 4.395 2.929 7.116 7.114 7.325 11.09zm-.837-8.161c0-2.72-2.093-5.65-5.023-7.324.21.628 1.884 2.302 3.139 4.186 1.047 1.674 1.465 2.719 1.884 3.138zM42.06 1.882c-1.047 3.558 0 8.58 3.348 12.765.209-.837-1.046-3.976-1.883-6.905-.628-2.72-.837-5.44-1.465-5.86ZM5.022 136.64c-3.139.209-3.766-.419-3.976-3.557 1.465 1.464 2.721 2.092 3.976 3.557zM.837 131.2c2.093 2.092 4.185 3.347 6.278 5.649 1.046.419 2.092.419 3.138-.418-3.347-3.557-6.486-5.65-10.044-9.207.209 1.255.419 2.72.628 3.976zM0 125.34c4.395 4.395 7.743 7.115 11.718 11.3 1.256.628 2.093.628 2.721 0-4.813-6.068-9.207-10.672-14.021-16.74C0 121.784 0 123.667 0 125.34Zm.837-6.696c5.441 6.277 10.672 11.719 16.322 18.624 1.673.837 2.929.837 3.557.209-5.44-7.114-12.345-14.856-18.623-22.599-.419 1.046-.628 1.883-1.047 2.72-.209.419-.209.628-.209 1.046zm1.465-5.23c7.114 8.16 13.602 15.484 21.134 24.481 1.047.628 2.093.628 2.93.21-.837-.837-5.859-6.905-6.696-7.952-6.068-7.532-9.626-11.509-16.531-19.879-.209 1.047-.419 2.093-.837 3.14zm1.256-4.395c7.532 8.37 10.253 12.137 18.414 21.762.837 1.256 5.231 5.65 6.067 6.696 1.047 2.093 4.605 2.093 2.93.628-1.465-1.674 0-.419-2.092-3.139-6.696-8.161-17.787-21.552-24.482-29.922-.21 1.464-.628 2.719-.837 3.975zm1.046-5.022c.209-1.255.418-2.302.628-3.348 6.277 7.951 18.623 22.809 25.737 31.597 3.767 4.603 3.558 4.394 5.651 6.696 0 1.046-.838.628-2.302.209-1.884-2.092-1.674-1.883-3.558-4.395-8.788-10.252-18.414-22.18-26.156-30.759zm.628-4.395c.418-1.464.418-3.138.627-4.602 6.696 10.462 16.322 21.552 26.994 31.387-.837-4.185-14.23-15.694-22.391-26.575-1.674-2.93-3.137-5.65-4.184-7.952.209-1.255.209-2.302.419-3.766 5.649 11.508 14.647 22.18 27.202 33.062-1.465-3.767-14.439-14.23-21.344-25.319-2.511-4.395-4.394-7.953-5.44-10.882v-1.883c5.65 11.3 15.484 23.017 27.203 33.061-1.256-3.766-14.648-14.647-21.135-25.319-2.721-4.603-4.395-8.16-5.649-11.09v-2.093c5.44 10.881 17.577 25.529 28.667 35.155-1.255-3.558-16.322-16.74-22.599-26.993-2.721-4.814-4.604-8.58-5.65-11.51v-2.929c4.603 10.881 16.322 25.32 27.83 34.735-1.255-3.557-15.694-15.484-21.553-25.319-3.139-5.23-4.813-9.207-5.858-12.137 0-1.045 0-2.3.209-3.138 3.975 11.09 15.066 24.482 26.784 33.48-1.256-3.138-14.648-14.02-20.088-23.226-3.558-6.069-5.232-10.044-6.488-12.974 0-1.256 0-2.302.21-3.558 3.348 10.881 13.811 24.064 25.529 33.271-.837-3.139-13.393-12.974-18.833-21.762-3.976-6.696-5.232-11.09-6.487-14.019v-.628c.209-1.256.209-2.72.419-3.976 2.302 10.881 12.346 24.901 24.273 34.526-.837-2.72-12.346-12.555-17.158-20.715-4.604-7.743-5.651-12.346-7.115-14.858C13.183 20.924 25.948 3.14 44.571 0l.419.209c-.628 3.557 0 7.951 2.091 12.136.419-.837-.627-5.022-.836-8.579V.627l1.674.419c.209 4.184 1.674 8.161 3.557 8.58-1.465-2.303-1.674-5.232-1.674-7.743l2.302.628c0 4.394 1.465 9.206 3.558 9.415-1.884-2.51-1.884-5.858-1.675-8.579l.419.21c.418 1.673 1.046 3.348 1.882 4.185.837-1.046.419-3.139-.208-5.44 2.301-1.256 5.022-1.047 7.951.837 1.047 1.255.628 1.882-.837 1.882h-1.465l3.349 1.465c.209.42.836.837-1.047 1.047L62.776 8.58l4.393.418c1.465.628 1.256 1.047.838 1.674l-1.047 1.255c3.767 0 7.743.837 12.556 3.35-.21 1.673-2.093 1.464-5.65-.42.837 2.093 4.185 2.302 3.975 3.558-.418 2.301-5.44.21-7.742 3.138l5.65.21c1.255.836.837 1.464-1.046 1.464 2.929 3.558 5.231 4.604 6.068 2.093.837-1.884 1.674-1.884 2.512 0 3.556 2.093 4.184 2.302 2.091 2.72l-3.347.628 3.975.628c1.046.418 1.046 1.255.419 1.882-2.72.42-2.929.838 2.092 1.047 2.093 1.046 2.93 2.092 2.093 2.93-4.395.21-4.185.837 1.046 1.255 1.256.628 1.675 1.465 1.465 2.093-2.72.627-2.302 1.255 1.046 1.255.418.627.837 1.046.209 1.674-3.138.837-2.72 1.255 1.256 1.255.209 1.465 2.511 1.256 3.348 3.14 3.348-.628 4.812 1.674 1.884 1.674l-.21.628c4.812.21 6.905 1.463 6.277 4.393-.418 1.256-6.905-2.51-4.184 7.533l1.045 1.046c1.884.42-.208-4.603 2.93-4.184.418.21.837 1.673.209 4.184-.627 2.302-2.092 3.35-4.393 1.884-2.093-1.465-3.349-2.93-3.14-4.604l.21-3.138c-2.302.21-2.721-1.256-2.93-3.558 0-.419-.837-.209-.628-.837-3.766-.628-5.44.628-6.486 3.348-.21 1.047-1.047.21-1.465-.837.209-.627-1.256.21-2.093-.209-.628 0-.418-1.465-1.046-1.256-.418 0-.418.628-1.255.628-.628-.209-.418-1.674-1.674-.418-.837.837-1.046.837-1.256-.419.21-1.046 1.046-3.138-1.255-.209-.837.418-1.047.418-1.465-.628-1.256-3.557-2.093-3.766-2.512-.628-.626 1.256-1.254 1.465-1.254-.418-1.256-5.44-1.465-5.44-1.046-.21-.21 2.302-.838 2.093-2.093-.628-1.465-4.393-2.093.42-3.139-1.673-1.465-2.51-.419-6.069-2.929-7.115l1.464 7.325c0 1.046-1.673 1.254-1.883-.419-.837-4.813-3.976-13.183-3.348-10.463l1.883 10.045c.21.837-2.092.418-2.511-.838L58.172 33.27c-.628-3.557-.628 6.696.837 11.091 0 .627-1.674.627-1.465-.21 0-1.046-1.882-12.974-2.51-12.346-1.465 1.465 2.51 13.393-.628 11.51-.419-.21-1.465-12.138-1.884-12.347-.209 0 0 11.51-.418 11.3-3.349-4.185.209-15.484-2.093-16.112-.418 0-1.465 13.81-1.883 13.391 1.465 10.672 10.044 11.091 9.416 14.23l-6.068-3.139c1.674 3.14 4.186 6.487 5.859 10.044-1.883.628.209 3.14 1.464 4.395-1.883-.21-1.464 1.046 2.093 4.393.837.628 1.047 1.256.837 1.884-4.394-1.047-4.813-1.047 2.302 4.604-4.394-.628-4.604-.209.419 3.138.837.628 1.882 1.883 2.092 3.14.209.836-.628.417-1.046.417-.837-.418-2.092-1.255-2.511-1.464-1.256-.21-.418 1.464 5.44 5.858 1.465 1.256 2.093 2.302 1.046 2.721-7.114-4.394-6.695-3.348 1.047 3.348 1.883 2.93 2.093 4.184 1.465 4.603-6.278-5.23-10.463-8.579.418 2.302 1.884 1.884 2.302 3.139.838 3.349-10.882-8.16-5.023-2.721 2.3 4.812.419.418 0 1.046-.417.837-10.463-7.742-10.881-5.859.208 5.65.419 1.046 1.046 1.883.628 2.72-.209.418-1.045 0-1.464-.21-7.534-7.114-6.906-5.649 1.673 6.069 1.256 1.883 1.884 3.557-.209 2.511-9.416-10.671-12.345-12.973-.209 3.348 1.255 2.093 1.465 3.139-.21 2.511-8.579-11.718-8.788-10.253-.417 2.302.627 1.464.627 1.673 0 1.464-7.743-9.416-10.044-11.717-.419 2.093 1.255 2.511 1.046 2.93-.209 1.674-9.416-11.718-9.625-10.253-.419 1.884.838 1.464 1.255 2.302-.209 1.674-10.881-12.346-10.881-11.928-.418 1.464.209 3.348.209 3.139-1.884 1.465-1.046-1.256-1.046-2.301-2.093-3.348-6.695-8.161-7.532-7.534.419 2.929-.837.837-1.883.837-3.139-.209-6.905-8.998-7.533-8.998-2.092-.419l-3.767-.628c-.627-1.254-1.255-1.882-2.093-2.719-6.486-6.278-8.788-6.906-2.302 1.255.21.21-.417.419-.209.628l-7.323-1.255c-.837 0-1.884-.419-2.72-1.465-3.139-5.441-5.022-7.533-10.253-12.556.418 1.884 4.394 5.232 7.533 10.463.837 3.349-2.93 1.883-4.186 1.256-2.301-3.139-3.138-3.558-6.486-7.533-9.417-11.091-19.461-23.646-27.621-32.435Zm25.319-87.885c.627.42 1.465 3.14 3.139 6.278 1.674 3.347 4.184 6.487 4.394 7.533-5.022-3.976-7.742-9.416-7.533-13.81zm-3.138 3.348c.836.837 1.464 3.558 3.347 7.324 2.093 3.767 5.441 7.533 5.441 8.788-5.441-4.603-8.788-10.88-8.788-16.112zm-2.93 3.767c1.046.837 1.674 3.975 3.975 8.161 2.302 4.184 6.278 8.58 6.488 9.835-6.488-5.023-10.463-12.137-10.463-17.996zm-2.511 3.766c.209 6.488 4.813 14.44 11.927 20.088-.209-1.465-5.022-6.277-7.533-11.09-2.72-4.603-3.348-7.952-4.394-8.998zm-2.302 3.976c.418 7.115 5.441 15.694 13.601 22.18-.418-1.673-5.858-7.114-8.788-12.345-2.93-5.232-3.767-8.788-4.813-9.835zm-2.092 3.976c.627 7.743 6.277 17.16 15.066 24.064-.419-1.883-6.696-7.533-9.835-13.393-3.349-5.649-3.977-9.416-5.231-10.67zm-2.093 3.976c.837 8.58 7.324 18.623 16.74 26.156-.419-2.093-7.323-8.37-11.091-14.647-3.347-6.069-4.184-10.044-5.649-11.509zm-1.674 3.976c.837 9.207 7.951 20.087 18.205 28.25-.628-2.303-8.161-8.999-12.137-15.696-3.766-6.695-4.603-10.88-6.068-12.554zm-1.465 4.184c.837 9.835 8.579 21.553 19.67 30.342-.838-2.51-8.998-9.835-13.393-17.158-4.184-7.116-4.812-11.509-6.277-13.184zm-1.674 3.977c1.465 10.462 10.253 23.854 21.972 33.27-.838-2.72-10.463-11.3-15.066-19.042-4.395-7.742-5.232-12.137-6.906-14.228zM38.293 5.44c.628.21 1.465 2.511 2.302 4.813.837 2.092 2.093 4.394 2.093 5.022-3.349-2.72-4.814-6.696-4.395-9.835zm54.615 55.242c-2.302-2.302-3.767.418-.628 3.348 2.72 2.511 5.65 1.675 4.812.837l-4.184-4.185zm-16.95-25.947c-.419 0 .209 2.511.418 3.767 0 1.255.419 2.092 1.256 3.138.837 1.046 1.256 1.256 1.047.837-.838-2.302-1.675-4.394-1.884-6.277 0-.837-.419-1.256-.837-1.465zm-2.929-3.139c-.418 0 .21 2.93.21 4.395 0 1.255.418 2.511 1.255 3.766.836 1.046 1.255 1.464 1.045 1.046-.836-2.929-1.673-5.23-1.673-7.533-.209-1.046-.627-1.465-.837-1.674zm-3.139-3.138c-.419-.21.209 3.138.209 4.812 0 1.674.21 3.14 1.256 4.604.837 1.255 1.256 1.673 1.046 1.046-.628-3.139-1.674-5.859-1.674-8.58 0-1.254-.209-1.673-.837-1.882zm-2.93-3.139c-.418-.419 0 3.557 0 5.44-.209 1.883.209 3.348 1.047 5.232 1.046 1.465 1.464 1.883 1.255 1.255-.628-3.767-1.465-6.906-1.465-9.834 0-1.466-.418-1.884-.837-2.093zm-2.929-3.349c-.418-.209 0 4.186-.209 6.278-.209 2.092.209 3.767 1.047 5.65.836 1.883 1.463 2.302 1.254 1.674-.627-4.185-1.464-7.742-1.254-11.09 0-1.465-.419-2.093-.838-2.512zm-3.139-3.138c-.418-.418 0 4.394-.209 6.905-.209 2.093 0 4.185 1.046 6.278.838 2.092 1.256 2.511 1.256 1.883-.628-4.603-1.465-8.579-1.256-12.346.21-1.673-.209-2.3-.837-2.72zm-2.72.21c-.209-.419-.209 3.556-.419 5.44-.209 1.883 0 3.557.837 5.231.628 1.674 1.047 2.092 1.047 1.464-.419-3.765-1.047-6.905-.838-9.835.21-1.463-.209-1.882-.627-2.3zm-2.301 0c-.419-.21-.419 2.928-.628 4.393-.209 1.256-.209 2.511.419 3.977.626 1.464.835 1.674.835 1.255-.209-2.93-.626-5.44-.209-7.743.209-1.045-.208-1.464-.417-1.882z",
    transform: "translate(253.82 90.396)",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.883.837C8.162 8.58 14.02 15.903 20.716 24.69c0 1.465-.628 2.302-2.302 2.302C11.509 17.158 6.278 9.207 1.046 1.673 0 .21 1.256 0 1.883.838ZM33.48 54.614c.628 1.675-.628 2.512-1.884.837-2.72-3.139-2.093-7.114.837-10.672 3.139-3.765 7.115-3.765 10.672-1.046 2.093 1.674 1.465 1.884-1.046 1.884-7.115 0-9.835 3.557-8.58 8.997zm7.323-3.347c-2.93-1.046-3.766.209-3.14 3.347 41.852 59.009 105.254 145.221 179.958 246.916l-.419 1.465 6.277 3.557-2.092-8.37-1.256.837C162.588 218.667 95.837 124.086 40.804 51.267Z",
    transform: "translate(92.07 33.27)",
    style: {
      fill: "#e2b700",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.149 14.439c0-1.465 5.442-5.231 12.556-10.044 3.139-2.511 6.068-3.348 8.788-3.348.837.209 2.093.418 3.767.209 1.675 1.046 1.047 1.883-.837 2.302-.837-.628-1.674-.837-2.511-.42-1.884.42-2.093 1.676-3.347 2.094l-.838-1.255c-2.511 1.673-4.185 6.277-6.068 8.579l-.419-2.302c-1.256.209-2.092 2.93-3.975 4.395.209-1.675-.21-2.512-.837-2.512-3.139 2.093-5.441 3.139-6.279 2.302zM65.077 124.086c1.884 0 3.558.628 3.558 1.256 0 .837-1.674 1.465-3.558 1.465-2.092 0-3.766-.628-3.766-1.465 0-.628 1.674-1.256 3.766-1.256zm14.23-2.929c1.255-1.883 2.719-2.72 3.138-2.301.418.627-.21 2.51-1.255 4.184-1.255 1.883-2.72 2.93-3.14 2.302-.417-.419.21-2.302 1.257-4.185zm-4.604 2.511c.837-1.465 1.883-2.302 2.302-1.884.418.419 0 1.884-.837 3.349-1.047 1.465-2.093 2.302-2.512 1.883-.418-.418 0-1.883 1.047-3.348zm-4.185.837c.837-1.256 1.673-1.884 1.883-1.674.418.418 0 1.674-.628 2.929-.836 1.047-1.673 1.675-2.092 1.465-.21-.418 0-1.674.837-2.72zM.837 109.648 0 111.949c1.047.21 1.884-1.255 2.93-1.882l-.837 3.766c1.256.209 4.185-2.93 6.277-4.394l-1.465 3.766c1.884 0 3.139-2.72 4.604-4.184l-.837 3.975c2.302-.21 3.767-3.138 5.65-4.812l-.42 3.765c1.675-.209 2.93-2.51 4.605-3.975l.837 2.72c1.465.209 2.302-1.883 3.557-2.72l.628 2.511 3.139-3.139.628 2.721 3.557-1.256 1.045 1.465 2.93-1.465-.21 3.138 3.977-1.673.419 2.092 2.929-1.674v2.72l3.348-.837.209 2.511 5.023-2.092-1.674 3.767 4.393-2.721-.627 2.93 4.813-2.093-2.721 4.395c3.139.209 4.186-2.093 6.278-3.139l-1.465 3.975c3.139-.627 5.859-3.138 8.58-6.486.628 1.046.209 2.72-2.093 6.278 3.348-1.465 5.022-3.767 6.277-6.278l-1.046 4.394c2.093-.209 4.185-1.883 6.069-4.813l-.21 4.185c1.675-1.255 2.929-2.929 3.766-5.022 2.093.837 4.395-.419 5.232-3.766 1.256-3.139.419-4.186-2.302-3.139-8.998 6.277-20.925 7.951-38.502 2.721-11.3-3.14-23.018-3.558-34.735-3.977-5.232-.209-9.626.628-11.72 5.441zm26.575-44.99c.837-1.464 2.51-2.72 4.604-3.974l.419 1.883 5.02-1.674.42 1.674 5.44-2.93c-3.138 3.975-3.766 5.65-2.72 5.65.837 0 4.813-4.603 6.068-3.348-2.72 4.185-.21 2.929 4.395-.837 1.256.419-1.674 3.347-1.256 3.766.419.419 2.093-.837 5.44-3.138.837-.628 2.72-2.721 3.139-1.674.21 1.255-1.046 1.883-1.674 2.72-3.348 3.975-2.511 3.348 3.349-.418.837-.42 2.092-1.465 2.929-1.047-3.976 5.23-2.301 4.185 3.557.628.837-.418 1.884-1.883 2.93-.837-7.324 6.487-6.07 7.324 3.347 2.72-4.393 5.022-3.347 5.23 3.558.837.628-.21 1.465 0 2.302-.42-3.14 3.14-3.558 5.442-2.093 4.605 2.302-1.046 5.23-2.302 6.696-1.883-2.93 2.93-2.72 4.185 1.046 3.558 1.256.418 0 1.883-3.766 4.393-.627 1.047-1.255 0-1.883-2.51-.418 1.464-1.046 1.464-1.674.627l-.837 5.44-1.256-.208v-3.14c-.628-.837-1.256-.837-1.883 0l-1.047 4.186L70.1 78.26c-.628 1.464-1.465 2.929-2.93 3.975-1.256-1.673-2.093-1.255-2.511.209-.838.209-1.256-.418-2.093-.21-.627 1.884-1.255 2.303-2.301 1.047-1.674 1.046-3.14 2.093-4.813 3.767l-.837-2.093c-1.465 2.093-2.72 3.349-3.557 2.93l-1.465-1.465-2.302 3.767-3.767 1.046c0 1.046 1.465 1.046 3.976.627 3.349-.418 9.835-1.882 14.02-3.138 4.185-1.256 8.789-1.883 13.81-3.976 3.977-1.883 8.58-5.231 13.184-7.533 1.046.837.209 2.93-8.58 9.835l-4.185-1.256 2.302 3.139c-1.046 1.047-1.883 1.465-2.93 1.256l-3.766-1.883 1.255 3.975c-2.72 0-3.975-3.348-6.486-1.883l1.046 3.139-5.65-1.675 1.046 3.767-4.812-2.092-1.047 2.092c-1.465 0-2.302.419-2.511 1.046 11.09 1.884 23.227-2.092 35.783-8.16.628-.21.836.209.836 1.255-1.046 5.022-4.603 9.417-10.253 13.392l1.674-6.696c-3.766 1.674-7.952 9.835-11.09 10.881l3.347-8.788-9.834 8.161c-.838-1.047.418-3.349 2.51-6.278-2.93 0-7.951 6.905-8.788 6.487-2.092-1.046 1.675-3.139 2.512-4.604-2.721-.21-4.604 2.302-6.906 3.558-.21-1.256 1.255-2.721 3.767-5.022l-8.161 3.766c0-1.465 3.139-2.721 3.766-4.812-3.766 2.51-7.114 4.184-7.951 3.975l2.51-3.975-7.114 3.766 4.394-4.604-7.532 3.557 2.092-3.975-5.441 3.556 2.302-4.393c-2.721 2.302-5.231 3.766-6.696 3.766 1.465-1.883 2.512-3.348 2.302-4.394-2.511 2.093-5.022 3.558-6.07 3.558l1.048-3.558c-2.093 2.093-4.394 3.558-6.905 4.394l2.51-4.185c.419-.628.21-1.464-.627-.837l-5.65 4.603c1.255-2.301 1.883-3.766 1.046-4.394l-3.975 2.093.419-2.302-4.604 5.022c-.628-.209.209-1.464.837-3.766l-4.814 3.14c2.512-5.022 6.697-8.371 12.346-10.044 6.696-2.093 11.928-2.302 16.112-2.93 7.325-1.046 11.928-1.674 17.788-4.395 2.719-1.046 5.858-2.301 9.207-5.021 1.673-1.256 1.046-1.675-.837-1.465l-7.533.418v-3.348l-2.93 3.976-.628-3.976-2.511 6.906-1.046-7.952-1.884 8.58-1.045-8.371-3.14 9.626-.837-10.045-1.883 10.254-1.883-10.463-1.255 10.463-2.093-9.835-.837 9.416-2.72-9.625-.21 10.044-3.14-9.626-.626 8.58-2.092-8.371-.837 7.534-1.675-6.906-1.046 7.534c-3.14-5.86-4.394-10.672-2.302-13.392 3.139-3.558 7.324-4.395 11.509-3.767zm23.855-22.807c.628 0 1.256.837 1.674 2.3.418 1.466.418 2.722.209 2.722-.627.209-1.255-.838-1.674-2.302-.418-1.255-.418-2.511-.21-2.72zM29.923 39.34c3.139-4.813 5.65-6.278 7.324-2.511 2.093-6.696 4.395-7.324 7.323-1.465 3.976 0 4.814 6.068 4.186 15.066l-3.767-10.044v6.487c-2.51-11.091-18.623-4.603-15.066-7.533zM99.395 2.93c4.603.419 9.207 2.092 13.601 4.603.209.628.418 1.047-.419.628-1.674-1.255-3.138-1.883-4.394-1.883.419 1.883.21 2.72-.627 2.51-1.675-2.929-3.14-3.348-4.395-2.72-.419.21-.628.42-1.047.21-1.255-2.72-1.882-2.72-2.51-1.674-1.255-1.046-1.255-1.674-.21-1.674zM75.749 4.186c-1.046.627-1.046 1.045-.21 1.254 1.466-1.254 2.93-1.463 4.814.42 0-2.721 1.045-2.511 3.348.836-.838-3.347 0-4.184 3.557.837 0-2.72.209-3.138 2.51 1.465.629.837 1.256.837 1.465.419-1.254-4.813-.626-4.604 2.093.418.837 1.047 1.256 1.047 1.256.419-.21-3.348 1.255-2.72 4.394 1.883.837 1.047 1.256 1.465 1.464.419-.627-2.721.628-2.512 3.349.837 2.092-.21 5.022 1.465 8.788 4.812.419.628.837.837 1.256.628-2.093-3.766.418-2.302 3.767 0 2.091-1.046 2.301-1.674 1.046-2.093-7.115-2.51-12.974-5.23-17.159-8.37-4.813-3.765-6.905-2.72-12.555-6.277C84.119 0 79.725 1.047 75.749 4.186Zm-10.253 6.696c-2.511.837-2.511 1.883-.21 2.302 1.047.209 1.884.209 2.72 0 1.466-.21 2.094 0 2.722 1.255 1.045 2.092 2.3 2.929 3.347 2.3.628-.627-3.975-3.974-1.674-3.974h1.255c3.558 3.347 6.906 5.23 6.697 4.603l-1.465-3.766c-.418-1.255 1.465-.628 2.302.209l4.813 4.185c.627.837 0-.628-.838-3.347-.418-.838.838-.838 1.674 0 2.93 2.928 6.487 7.95 6.487 6.067v-1.883c0-.837 1.046-.837 1.674 0 1.674 2.093 3.976 3.976 3.767 3.139l-.418-1.674c-.21-1.046.627-1.046 1.883 0l5.022 4.185c1.046.836 1.883.419 1.464-.21l-.837-1.255c-.627-1.046-.209-1.255 1.047-.418l4.394 3.138c.836.628.836-.21-.419-2.092h2.511c.419 1.464 1.465 1.883 3.976 2.929.628.419.838-.42 2.092-.837l6.069-1.882c1.883-.628 1.674-1.884 0-1.465-8.788 2.302-17.995-2.093-27.83-7.533-12.974-6.906-23.437-6.906-32.225-3.976zm86.211 4.812c.419.418 0 1.046-.628 1.883-.628.628-1.464.837-1.883.628-.209-.418 0-1.255.628-1.883.837-.628 1.465-.837 1.883-.628zm6.696 1.674c-1.464-1.046-2.092 1.465.418.628l3.558-3.138c1.674-2.93.628.836 1.674.627 1.256-.418 3.138-4.185 2.72-5.65l2.93-1.465c1.674-1.464 1.255-2.092-1.047-1.883-2.719 2.093-5.44 4.395-7.742 7.534l-2.511 3.347z",
    transform: "translate(86.211 85.583)",
    style: {
      fill: "#0092d0",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoscow);
export default __webpack_public_path__ + "static/media/moscow.a5225f37070071b2dee63958e2d84712.svg";
export { ForwardRef as ReactComponent };